{
  "Actions": {
    "actions": "Műveletek",
    "back": "Vissza",
    "click here": "Kattintson ide",
    "collapse": "Összecsukás",
    "expand": "Bővítés",
    "go to vehicle": "Ugrás a járműre"
  },
  "Alert": {
    "Account is already activated": "A fiók már aktiválva van.",
    "action failed": "A művelet hiba miatt nem sikerült",
    "add company card success": "Új vállalati kártya sikeresen hozzáadva.",
    "add driver success": "A járművezető hozzáadása sikeresen megtörtént",
    "add integration success": "Az integráció sikeresen létrejött.",
    "add vehicle empty imei info": {
      "description": "A járműhöz nincs hozzárendelve IMEI-szám, ezért nem lehet fájlokat letölteni. Adjon meg érvényes IMEI-számot a járműfájlok letöltéséhez.",
      "title": "A jármű hozzáadása sikeresen megtörtént, de IMEI-szám nem lett hozzárendelve."
    },
    "add vehicle success": "A jármű hozzáadása sikeresen megtörtént",
    "An unhandled error occured while processing this request": "A kérés feldolgozása közben kezelhetetlen hiba történt.",
    "Another driver is registered under this card number.": "Ezen a kártyaszám alatt egy másik járművezető is regisztrálva van.",
    "apply all driver schedules success": "Az ütemterv sikeresen hozzáadva minden járművezetőhöz.",
    "apply all vehicle schedules success": "Az ütemterv sikeresen hozzáadva az összes járműhöz.",
    "apply driver schedules success": "Az ütemterv sikeresen hozzáadva a {{resourceCount}} járművezetőkhöz.",
    "apply vehicle schedules success": "Az ütemterv sikeresen hozzáadva a {{resourceCount}} járműhöz.",
    "cancel invitation success": "A meghívás törlése sikeresen megtörtént.",
    "Card number must be 16 characters in length.": "A járművezető azonosítójának hossza 16 karakternek kell lennie.",
    "CCA file download success": "A Company Card Authenticator letöltése sikeresen befejeződött.",
    "Comment must not be longer than 255 characters.": "A leíráshoz megengedett karakterek száma 255.",
    "Company card with such ID already exists.": "Ilyen azonosítóval rendelkező vállalati kártya már létezik.",
    "Company card with such name already exists.": "Ilyen nevű vállalati kártya már létezik.",
    "Company not found": "A vállalat nem található.",
    "Company not found.": "A vállalat nem található.",
    "Company with this LZ client code already exists.": "A Teltonika-kóddal rendelkező vállalat már létezik.",
    "create client company success": "Új ügyfélcég létrehozása sikeresen megtörtént.",
    "create company success": "A cég létrehozása sikeresen megtörtént.",
    "create schedule success": "Az új menetrend sikeresen létrehozva.",
    "credits overdraft activated": "A hitelkeret-túllépés sikeresen aktiválva",
    "credits overdraft deactivated": "A hitelkeret-túllépés sikeresen deaktiválva",
    "disable integration success": "Az integráció letiltása sikeresen megtörtént.",
    "Driver duplication.": "Járművezető-adatok duplikálása.",
    "Driver name contains invalid characters.": "A járművezető neve érvénytelen karaktereket tartalmaz.",
    "Driver name must be 3-50 characters long.": "A járművezető nevének hossza 3–50 karakter között kell lennie.",
    "Driver with such card number already exists.": "A járművezető azonosítója már létezik.",
    "Drivers schedules were not found": "A járművezetők menetrendjei nem találhatók.",
    "edit company card success": "A vállalati kártya szerkesztése sikeresen megtörtént.",
    "edit integration success": "Az integráció szerkesztése sikeresen befejeződött.",
    "edit schedule success": "Az ütemterv szerkesztése sikeresen befejeződött.",
    "edit user description": "A módosítások akkor lépnek életbe, amikor a szerkesztő felhasználó kijelentkezik.",
    "Email recipient was not found.": "Az e-mail címzettje nem található.",
    "email transfer edit recipient success": "Az e-mail címzett adatai sikeresen módosultak.",
    "email transfer new recipient success": "Az e-mail címzett sikeresen hozzáadva.",
    "email transfer remove recipient success": "Az e-mail címzett sikeresen eltávolításra került.",
    "enable integration success": "Az integráció sikeresen engedélyezve.",
    "error": {
      "import failed": "A fájl importálása nem sikerült. Távolítsa el a fájlt, ellenőrizze, hogy az adatok megfelelnek-e a kívánt szerkezetnek, majd töltse fel újra a fájlt.",
      "import failed description": "Távolítsa el a fájlt, ellenőrizze, hogy az adatok megfelelnek-e a kívánt szerkezetnek, majd töltse fel újra a fájlt.",
      "import failed title": "Az importálás sikertelen. Az adatok nem felelnek meg a fájlszerkezetnek."
    },
    "general settings update success": "A beállítások módosítása sikeresen megtörtént.",
    "global schedule success": "A globális ütemterv sikeresen létrehozásra került.",
    "Id must be of digits and letters only": "Az azonosító kizárólag számokból és betűkből állhat",
    "Id must be of length 6 to 8": "Az azonosító hossza 6–8 karakter között kell lennie",
    "Imei must be 15 characters long.": "Az IMEI-számnak 15 karakter hosszúnak kell lennie.",
    "Imei must be numeric.": "Az IMEI mezőben csak numerikus értékek megadhatók.",
    "integration editing cancelled": "Az integráció szerkesztése törölve.",
    "Integration is disabled. Enable it first before retrying": "Az integráció le van tiltva. Kérjük, először engedélyezze, majd próbálja meg újra.",
    "Invalid email address": "Érvénytelen e-mail-cím.",
    "Invalid format.": "A fájl formátuma érvénytelen",
    "LZ client code not found.": "A Teltonika kód nem található.",
    "move company success": "A „{{sourceCompany}}” vállalat áthelyezése a „{{targetCompany}}” vállalathoz sikeresen megtörtént.",
    "New name must be different from the current name.": "Az új névnek különböznie kell a jelenlegi névtől.",
    "news created": "A hír létrehozása sikeresen megtörtént.",
    "news deleted": "A hír sikeresen törölve.",
    "news edited": "A hír sikeresen szerkesztve.",
    "news published": "A hír sikeresen közzétételre került.",
    "Number must be provided.": "A számot meg kell adni.",
    "Number must not be longer than 30 characters.": "A járműszámra megengedett karakterek száma 30.",
    "One or more selected companies have child companies and cannot be deleted.": "Egy vagy több kiválasztott vállalatnak leányvállalatai vannak, ezért azokat nem lehet törölni.",
    "One or more validation errors occured while parsing csv file. Please use template file for reference.": "A CSV-fájl feldolgozása során egy vagy több érvényesítési hiba történt. Kérjük, használja a sablonfájlt referenciaként.",
    "One or more validation errors occured.": "Egy vagy több érvényesítési hiba történt.",
    "quick schedule created": {
      "description": {
        "drivers": "Az adatletöltés megkezdődik, amint a rendszer észleli a járművezető TachoSync-hez való csatlakozását.",
        "vehicles": "Az adatletöltés megkezdődik, amint a jármű kapcsolata a TachoSync-kel azonosításra kerül."
      },
      "title": "A gyors ütemterv sikeresen létrehozva.",
      "title multiple drivers": "A {{driverNum}} járművezető számára sikeresen létrehoztuk a gyors menetrendet.",
      "title multiple vehicles": "A {{vehicleNum}} járműre vonatkozó gyors ütemterv sikeresen létrehozva.",
      "title single driver": "A gyors ütemterv sikeresen létrehozva."
    },
    "Quick schedule for vehicle is already created.": "A jármű gyors ütemterve már elkészült.",
    "Quick schedule is already assigned to the driver.": "A sofőrnek már hozzárendelték a gyors menetrendet.",
    "remove company card success": "A vállalati kártya eltávolítása sikeresen megtörtént.",
    "resend invitation success": "A meghívót sikeresen újraküldtük.",
    "retry integration success": "A „{{integrationName}}” integrációja sikeresen megtörtént.",
    "retry interrupted integration success": "Az „{{integrationName}}” integráció újra megpróbálja szinkronizálni a kihagyott fájlokat. Kérjük, később térjen vissza, hogy ellenőrizze az állapotot.",
    "session expired": "A munkamenet lejárt. Kérjük, jelentkezzen be újra.",
    "successfully activate vehicle multiple": "{{resourceString}} jármű sikeresen aktiválva.",
    "successfully activate vehicle single": "A jármű aktiválása sikeresen megtörtént.",
    "successfully assigned schedules": {
      "multiple": "A menetrendek sikeresen hozzárendelve.",
      "single": "Az ütemezés sikeresen hozzárendelve."
    },
    "successfully deactivate vehicle multiple": "{{resourceString}} járművet sikeresen deaktiváltunk.",
    "successfully deactivate vehicle single": "A jármű deaktiválása sikeresen megtörtént.",
    "successfully deleted": "A {{resourceString}} sikeresen törölve.",
    "successfully edited": "A {{resourceString}} szerkesztése sikeresen befejeződött.",
    "successfully exported": "$t(General##{{tableName}}) sikeresen exportálva.",
    "successfully imported": "A {{resourceString}} sikeresen importálva.",
    "successfully move vehicles multiple": "A {{resourceString}} sikeresen átkerült a {{companyString}}-be.",
    "successfully move vehicles single": "A {{resourceString}} sikeresen átkerült a {{companyString}}-be.",
    "successfully remove driver schedules multiple": "A menetrendeket sikeresen eltávolítottuk a {{resourceString}} járművezetők rendszeréből.",
    "successfully remove driver schedules single": "A menetrendek sikeresen eltávolításra kerültek a {{resourceString}} járművezetőtől.",
    "successfully remove vehicle schedules multiple": "A menetrendeket sikeresen eltávolítottuk a {{resourceString}} járművekből.",
    "successfully remove vehicle schedules single": "A menetrendek sikeresen eltávolításra kerültek a {{resourceString}} járműből.",
    "successfully removed": "A {{resourceString}} sikeresen eltávolítva.",
    "The company with such name already exists.": "Ilyen nevű cég már létezik.",
    "User is already invited.": "A felhasználót már meghívták.",
    "User is not invited": "A felhasználó nincs meghívva.",
    "Vehicle duplication.": "Jármű duplikálása.",
    "Vehicle number contains invalid characters.": "A járműszám érvénytelen karaktereket tartalmaz.",
    "Vehicle schedule was not found": "A jármű menetrendje nem található.",
    "Vehicle successfully activated": "A jármű aktiválása sikeresen megtörtént.",
    "Vehicle with such IMEI already exists.": "Az adott IMEI-számmal rendelkező jármű már létezik",
    "Vehicle with such Imei number already exists.": "Az IMEI már létezik.",
    "Vehicle with such number (VRN) already exists.": "Az adott VRN-számmal rendelkező jármű már létezik",
    "Vehicles schedules were not found": "Nem találtak járműmenetrendeket.",
    "You cannot delete a company you are a member of.": "A jelenleg kiválasztott vállalatot nem lehet törölni. Kérjük, válasszon ki egy másik vállalatot, és ismételje meg a műveletet."
  },
  "Auth": {
    "account verification": {
      "check autheticator": "Ellenőrizze az azonosító alkalmazását",
      "check email": "Ellenőrizze az e-mailjeit",
      "code required": "Ellenőrző kód szükséges.",
      "code sent to email": "A kódot elküldtük az Ön e-mail címére",
      "code valid": "A kód néhány percig érvényes.",
      "enter code below": "és írja be az alábbi kódot a bejelentkezéshez."
    },
    "account verification description": "Ellenőrző kód szükséges. Ellenőrizze az azonosító alkalmazását, és írja be az alábbi kódot a bejelentkezéshez.",
    "authenticator": "Hitelesítő alkalmazás",
    "authenticator verification description": "Ellenőrző kód szükséges. Ellenőrizze az azonosító alkalmazását, és írja be az alábbi kódot a bejelentkezéshez.",
    "back to sign in screen": "Vissza a bejelentkezési képernyőre",
    "check email": "Kérjük, ellenőrizze a beérkezett leveleket, és kattintson a kapott linkre a jelszó visszaállításához.",
    "community forum": "Közösségi támogatási fórum",
    "contact us": "Vegye fel velünk a kapcsolatot",
    "create password": "Jelszó létrehozása",
    "did not receive": "Nem kapta meg a linket?",
    "do not have account": "Még nincs fiókja?",
    "email": "E-mail",
    "enter current password": "Írja be az aktuális jelszót",
    "enter email": "Kérjük, írja be az alábbi mezőbe a regisztrált e-mail címét, hogy megkapja a jelszó-visszaállítási utasításokat.",
    "enter here": "Itt lépjen be",
    "enter new password": "Új jelszó megadása",
    "enter numbers only": "Kérjük, csak számokat (0–9) írjon be",
    "example": "Például:",
    "failed to login": "A megadott e-mail-cím vagy jelszó helytelen.",
    "forgot password": "Elfelejtette a jelszavát?",
    "forgot your password": "Elfelejtette a jelszavát?",
    "go to login": "Bejelentkezés",
    "google authenticator": "Google Authenticator",
    "hide password": "Jelszó elrejtése",
    "invalid email format": "Érvénytelen e-mail formátum",
    "invalid password format": "Érvénytelen jelszóformátum",
    "Invitation expired": "A meghívó linkje lejárt vagy törlésre került.",
    "link sent": "A link elküldve!",
    "login title": "Bejelentkezés",
    "microsoft authenticator": "Microsoft Authenticator",
    "new password": "Új jelszó",
    "password": "Jelszó",
    "password changed": "A jelszó megváltoztatása sikeresen megtörtént.",
    "privacy policy": "A <1>TachoSync</1> használatával Ön elfogadja a <3>Adatvédelmi irányelveinket</3>.",
    "remember password": "Emlékszik a jelszavára?",
    "repeat new password": "Ismételje meg az új jelszót",
    "repeat password": "Ismételje meg a jelszót",
    "required": "Szükséges",
    "resend": "Újraküldés",
    "reset password": "Jelszó visszaállítása",
    "send reset link": "Visszaállítási link küldése",
    "show password": "Jelszó megjelenítése",
    "sign in": "Bejelentkezés",
    "sign in to tacho": "Jelentkezzen be a\nTachoSync-fiókjába",
    "sign out": "Kijelentkezés",
    "sign up": "Regisztráció",
    "teltonika telematics": "Teltonika Telematics",
    "terms and conditions": "Megértettem és elfogadom a Teltonika <1>Szolgáltatási feltételeit</1> és a <2>Adatkezelési megállapodást</2>.",
    "wiki": "Telematika Wiki Tudásbázis"
  },
  "Button": {
    "accept": "Elfogadás",
    "accept all": "Mindet elfogadom",
    "accept selected": "Kiválasztottak elfogadása",
    "actions": "Műveletek",
    "activate": "Aktiválás",
    "add": "Hozzáadás",
    "add driver": "Sofőr hozzáadása",
    "add integration": "Integráció hozzáadása",
    "add to schedule": "Hozzáadás a menetrendhez",
    "add vehicle": "Jármű hozzáadása",
    "all drivers": "Minden járművezető",
    "all vehicles": "Minden jármű",
    "apply": "Jelentkezés",
    "assign": "Hozzárendelés",
    "back": "Vissza",
    "back to sign in": "Vissza a bejelentkezéshez",
    "cancel": "Mégse",
    "change": "Módosítás",
    "child company": "Leányvállalat",
    "clear": "Törlés",
    "clear all": "Összes törlése",
    "close": "Bezárás",
    "confirm": "Megerősítés",
    "continue": "Tovább",
    "continue to TachoSync": "Tovább a TachoSync-hez",
    "copied": "Másolva",
    "copy to clipboard": "Másolás a vágólapra",
    "create": "Létrehozás",
    "create schedule": "Menetrend létrehozása",
    "deactivate": "Deaktiválás",
    "default view": "Alapértelmezett nézet",
    "delete": "Törlés",
    "deselect all": "Minden kijelölésének megszüntetése",
    "disable": "Letiltás",
    "don't apply": "Ne jelentkezz",
    "download": "Letöltés",
    "edit": "Szerkesztés",
    "edit driver": "Járművezető szerkesztése",
    "edit integration": "Integráció szerkesztése",
    "edit vehicle": "Jármű szerkesztése",
    "enable": "Engedélyezés",
    "export": "Export",
    "export drivers": "Sofőrök exportálása",
    "export vehicles": "Járművek exportálása",
    "file settings": "Fájlbeállítások",
    "filtered": "Szűrt",
    "filters": "Szűrők",
    "find device": "Eszköz keresése",
    "finish": "Befejezés",
    "first page": "Első oldal",
    "generate": "Létrehozás",
    "generate report": "Jelentés létrehozása",
    "get started": "Kezdés",
    "go back": "Vissza",
    "import": "Import",
    "import drivers": "Sofőrök importálása",
    "import vehicles": "Járműimport",
    "inline actions": {
      "cancel invitation": "Meghívás törlése",
      "download file driver": "Letöltés",
      "download file vehicle": "Letöltés",
      "download monitoring": "Letöltésfigyelés",
      "download status": "Letöltés állapota",
      "edit analysis provider": "Szerkesztés",
      "edit company": "Cég szerkesztése",
      "edit driver": "Járművezető szerkesztése",
      "edit integration": "Integráció szerkesztése",
      "edit user": "Felhasználó szerkesztése",
      "edit vehicle": "Jármű szerkesztése",
      "resend invitation": "Meghívó újraküldése",
      "retry analysis provider": "Újrapróbálás",
      "retry integration": "Újrapróbálás"
    },
    "invite": "Meghívás",
    "invite user": "Felhasználó meghívása",
    "history": "Előzmények",
    "last page": "Utolsó oldal",
    "max download files": "Egyszerre csak {{maxNumber}} fájlt tölthet le.",
    "more actions": "További műveletek",
    "more filters": "További szűrők",
    "more options": "További lehetőségek",
    "move": "Áthelyezés",
    "new client": "Új ügyfél",
    "next": "Következő",
    "next month": "Jövő hónap",
    "next page": "Következő oldal",
    "only essential": "Csak a legfontosabbak",
    "open TachoSync": "TachoSync megnyitása",
    "pages of": "{{total}}",
    "pause": "Szünet",
    "previous": "Előző",
    "previous month": "Előző hónap",
    "previous page": "Előző oldal",
    "quick schedule": "Gyors ütemterv",
    "refresh page": "Oldal frissítése",
    "reject all": "Mindet elutasít",
    "remove": "Eltávolítás",
    "remove schedules": "Menetrendek eltávolítása",
    "reset": "Visszaállítás",
    "reset to default": "Alapértelmezett beállítások visszaállítása",
    "resume": "Önéletrajz",
    "return home": "Menjünk haza",
    "rows selected": "{{count}} Kiválasztva",
    "save": "Mentés",
    "schedules": "Menetrendek",
    "select image": "Kép kiválasztása",
    "select rows": "Sorok kijelölése",
    "selected": "Kiválasztott",
    "send code": "Kód elküldése",
    "settings": "Beállítások",
    "table view": "Táblázati nézet",
    "testing connection": "Kapcsolat tesztelése...",
    "verify": "Ellenőrzés",
    "yes": "Igen"
  },
  "Company cards": {
    "add new": "Új hozzáadása",
    "badge tooltip": {
      "Disconnected": "Megszakadt a kapcsolat a TachoSync-kel.\nUtolsó kapcsolat: {{connectionDate}}.",
      "Expired": "A kártya lejárt, ezért deaktiválásra került.",
      "Inactive": "Soha nem sikerült kapcsolatot létesíteni a TachoSync alkalmazással.",
      "Online": "Sikeresen csatlakozott a TachoSync-hez, és aktívan kommunikál."
    },
    "card expired": "A kártya lejárt: {{date}}",
    "card id": "Kártyaazonosító",
    "card number": "Kártyaszám",
    "card number tooltip": "A kártyaszám az első sikeres hitelesítés után jelenik meg.",
    "cca version": "CCA verzió",
    "company card id": "Cégkártya-azonosító",
    "edit card": "Kártya szerkesztése",
    "edit company card": "Cégadatlap szerkesztése",
    "expiry": "Lejárat",
    "expiry date": "Lejárati dátum: {{date}}",
    "expiry tooltip": "A kártya lejárati dátuma az első sikeres hitelesítés után jelenik meg.",
    "latest version": "Legfrissebb",
    "remove card": "Kártya eltávolítása",
    "remove company card": "Cégkártya eltávolítása?",
    "remove company card description": "Biztosan el akarja távolítani a „{{cardName}}” vállalati kártyát? Ez a művelet visszafordíthatatlan.",
    "status": "Állapot",
    "update version warning": "Elérhető egy újabb verzió.  A legjobb teljesítmény érdekében javasoljuk a frissítést.",
    "valid until": "Érvényességi idő",
    "version details after connection is established": "A verzió adatai a vállalati kártyával történő első csatlakozás után jelennek meg itt."
  },
  "Cookies": {
    "accept": "Elfogadás",
    "always active": "Mindig aktív",
    "analytics cookies": "Elemzési cookie-k",
    "analytics cookies description": "Ezeket a nyomkövetőket elemzési célokra használjuk, hogy olyan adatokat gyűjtsünk, amelyek segítségével megérthetjük, hogyan használják a felhasználók a weboldalainkat. Ezek az információk lehetővé teszik számunkra, hogy javítsuk a tartalmat, és olyan funkciókat fejlesszünk, amelyek javítják a felhasználói élményt. Ez a cookie-kategória letiltható.",
    "cookie banner message": "Mi és kiválasztott harmadik felek cookie-kat vagy hasonló technológiákat használunk technikai célokra, valamint az Ön hozzájárulásával a <1>cookie-irányelvben</1> meghatározott egyéb célokra is.",
    "cookie modal title": "Cookie-kat használunk",
    "cookie policy": "süti-irányelvek",
    "essential cookies": "Alapvető cookie-k",
    "essential cookies description": "Ezeket a nyomkövetőket kizárólag az Ön által tőlünk igényelt szolgáltatás működtetéséhez vagy nyújtásához feltétlenül szükséges tevékenységekhez használjuk, és ezek a cookie-k nem gyűjtenek Önről olyan információkat, amelyek marketing célokra felhasználhatók lennének, és nem jegyzik meg, hogy hol járt az interneten. Ez a cookie-kategória nem kapcsolható ki.",
    "text": "Ez a weboldal olyan adatokat tárol, mint például a cookie-k, hogy biztosítsa a weboldal szükséges funkcióinak működését, beleértve az elemzéseket is."
  },
  "Dashboard": {
    "added": "Hozzáadva",
    "Available": "Elérhető",
    "cards": "Kártyák",
    "card tooltips": {
      "connectivity": "<strong>Online:</strong>\nAz eszköz az elmúlt 24 órában csatlakozott\n\n<strong>Offline:</strong>\nAz eszköz az elmúlt 24 órában nem csatlakozott\n\n<strong>Inaktív:</strong>\nAz eszköz még soha nem létesített sikeres kapcsolatot a TachoSync-kel",
      "driver downloads": "<strong>Időben:</strong>\n0–14 nap telt el az utolsó letöltés óta\n\n<strong>Hamarosan esedékes:</strong>\n15–28 nap telt el az utolsó letöltés óta\n\n<strong>Késedelmes:</strong>\n29 vagy több nap telt el az utolsó letöltés óta\n\n<strong>Nincs letöltés:</strong>\nEddig még nem történt letöltés",
      "vehicle downloads": "<strong>Időben:</strong>\n0–60 nap telt el az utolsó letöltés óta\n\n<strong>Hamarosan esedékes:</strong>\n61–90 nap telt el az utolsó letöltés óta\n\n<strong>Késedelmes:</strong>\n91 vagy több nap telt el az utolsó letöltés óta\n\n<strong>Nincs letöltés:</strong>\nMég nem történt letöltés"
    },
    "cc expiry": {
      "expired": "Lejárt",
      "near expiry": "Lejárás közeledik",
      "near expiry tooltip": "3 hónapon belül lejár",
      "upcoming expiry": "Közeledő lejárat",
      "upcoming expiry tooltip": "3–6 hónapon belül lejár"
    },
    "company cards": "Céges kártyák",
    "company cards expiration": "Céges kártyák lejárati ideje",
    "connectivity": "Kapcsolat",
    "connectivity tabs": {
      "company cards": "Céges kártyák",
      "devices": "Eszközök"
    },
    "credit overdraft activated": "A folyószámlahitel segítségével egyenlegén felül akár {{overDraftAmount}} kreditet is felhasználhat.",
    "credits": "Kreditek",
    "credits health": {
      "Healthy": "Jó állapotú",
      "InOverdraft": "Folyószámlahitel",
      "LimitReached": "Elérte a korlátot",
      "LowCredits": "Alacsony kreditállomány",
      "OverdraftLimitReached": "Elérte a korlátot"
    },
    "credits history": "Hitelelőzmények",
    "credits history actions": {
      "BonusCredits": "Bónuszpontok",
      "CreditsExpiration": "A kreditek lejárata",
      "Deduction": "Havi levonás",
      "FreeTrial": "Bemutató kreditek hozzáadva",
      "MonthlyDeduction": "Havi levonás",
      "Purchase": "Hitelpontok hozzáadva",
      "WebTachoLicenseConversion": "Áttérés"
    },
    "credits statuses": {
      "available": "Elérhető",
      "balance": "Egyenleg",
      "overdraft": "Folyószámlahitel",
      "remaining overdraft": "Fennmaradó folyószámlahitel",
      "reserved": "Foglalt"
    },
    "Deactivated": "Deaktiválva",
    "deducted": "Levont",
    "demo credits": {
      "demo": "Bemutató",
      "demo credits expired tooltip": "A bemutató kreditek lejártak. Kérjük, vásároljon krediteket a TachoSync használatának folytatásához.",
      "demo credits used up tooltip": "Az összes bemutató kredit felhasználásra került. Kérjük, vásároljon krediteket a TachoSync használatának folytatásához.",
      "demo info tooltip": "A bemutató kreditek az első IMEI-kapcsolat létrehozásakor aktiválódnak, és 90 napig érvényesek."
    },
    "device status": "Az eszköz állapota",
    "devices": "Eszközök",
    "driver data": "Járművezetői adatok",
    "driver downloads": "A járművezetők letöltései",
    "DueSoon": "Hamarosan esedékes",
    "estimated": "Becsült",
    "expires": "Lejár",
    "how credits work": {
      "bottom content": {
        "header": "Mikor kerül jóváírásra a hitel?",
        "table": {
          "body": {
            "any": "Bármelyik",
            "any behaviour": "Nincs új jóváírás. A meglévő foglalás a hónap végéig érvényben marad.",
            "newly assigned": "Újonnan hozzárendelve",
            "newly assigned behaviour": "Csatlakozáskor fenntartva. Az első letöltés után átkerül a VIN-be.",
            "replaced vin known": "Kicserélve (VIN ismert)",
            "replaced vin known behaviour": "Nincs új jóváírás. A meglévő foglalás továbbra is érvényben marad.",
            "none": "Nincs",
            "none behaviour": "Nincs előre lefoglalt adatforgalom. A letöltés csak akkor kezdődik meg, ha egy eszközt hozzárendeltek."
          },
          "head": {
            "credit behaviour": "Hitelviselkedés",
            "device": "Eszköz",
            "vehicle status": "Járműállapot"
          }
        }
      },
      "button tooltip": "Ismerje meg a kreditek működését",
      "main description": "A TachoSync kreditek 12 hónapig érvényesek. Minden új vásárlás további 12 hónappal meghosszabbítja a lejárati dátumot, így biztosítva, hogy kreditjei addig álljanak rendelkezésre, amíg aktív felhasználó marad.",
      "main title": "Hogyan működnek a kreditek?",
      "middle content": {
        "description": "A flotta kreditfelhasználása pontosan tükrözi, hogy hány jármű van aktív állapotban, az egyedi alvázszám (VIN) alapján. Az eszközöket kicserélhetik, járművek között áthelyezhetik, vagy leányvállalatok között átruházhatják anélkül, hogy további kreditet fogyasztanának, feltéve, hogy a jármű azonosítása már megtörtént.",
        "header": "A kreditek aktív járművenként, nem pedig eszközönként kerülnek jóváírásra.",
        "read more on wiki": "További információk a Wikin"
      },
      "top content": {
        "active vehicle": "Aktív jármű",
        "device can change freely": "Az eszköz szabadon cserélhető",
        "equals one credit": "= 1 kredit",
        "identified by IMEI": "IMEI-szám alapján azonosítva",
        "identified by VIN": "VIN-szám alapján azonosítva",
        "tracking device": "Nyomkövető eszköz"
      }
    },
    "Inactive": "Inaktív",
    "last 12 months": "Az elmúlt 12 hónap",
    "news": "Hírek",
    "no history to show": "Nincs megjeleníthető előzmény",
    "no news": "Nincs megjeleníthető hír",
    "no results": "Nincs találat",
    "NoDownloads": "Nincs letöltés",
    "Offline": "Offline",
    "Online": "Online",
    "OnTime": "Időben",
    "Overdue": "Késedelmes",
    "Remaining": "Maradt",
    "Reserved": "Foglalt",
    "response error": "Hiba történt. Kérjük, frissítse az oldalt",
    "timeline": "Idővonal",
    "tooltip": {
      "click to expand": "Kattintson a kibontáshoz",
      "connected card expire soon": "A kártya hamarosan lejár: {{expirationDate}}",
      "disconnected card": "A vállalati kártya kapcsolata megszakadt.\nUtoljára látható: {{lastSeen}}.",
      "disconnected card expire soon": "A vállalati kártya kapcsolata megszakadt.\nUtoljára látható: {{lastSeen}}. \n \n A kártya hamarosan lejár: {{expirationDate}}.",
      "expired card": "A kártya érvényessége {{expirationDate}}-án lejárt.\nCserélje ki a vállalati kártyát egy érvényesre.",
      "offline card": "A vállalati kártya offline állapotban van.\nUtoljára látták: {{lastSeen}}.",
      "take me there": "Vigyen oda"
    },
    "Upcoming charge": "Közelgő díj",
    "vehicle data": "Járműadatok",
    "vehicle downloads": "Járműadatok letöltése",
    "view history": "Előzmények megtekintése"
  },
  "Date picker": {
    "disableFuture": "Letiltás dátuma",
    "disablePast": "Letiltás dátuma",
    "invalid date format": "Érvénytelen dátumformátum",
    "invalidDate": "Érvénytelen dátum",
    "maxDate": "Helytelen dátum",
    "minDate": "Helytelen dátum",
    "shouldDisableDate": "Letiltás dátuma"
  },
  "Details": {
    "activities": "Tevékenységek",
    "add new email recipient": {
      "choose a file format": "Válasszon fájlformátumot",
      "enter email": "Írja be az e-mail címet",
      "title": "Új címzett hozzáadása"
    },
    "api company id": "API vállalati azonosító",
    "autoAssignGlobalScheduleToDriver": "Globális menetrend hozzárendelése új járművezetőkhöz",
    "autoAssignGlobalScheduleToVehicle": "Globális ütemterv hozzárendelése új járművekhez",
    "automaticDriverRegistrationEnabled": "Új járművezetők automatikus regisztrációja",
    "card holder": "A kártyatulajdonos neve",
    "client code": "Ügyfélkód",
    "close details": "Részletek bezárása",
    "company": "Vállalat",
    "company cards": "Céges kártyák",
    "company cards limit reached": "Elérte a maximális vállalati kártyák számát a {{currCount}}/{{maxCount}} vállalatnál.",
    "company settings": "Vállalati beállítások",
    "Completed": "Befejezve",
    "connection settings": "Kapcsolatbeállítások",
    "creator": "Készítő",
    "credits": "Kreditek",
    "credits overdraft tooltip": "A havi hitelkeret-foglalási logikát frissítettük, hogy a számlán negatív egyenleg is megengedett legyen. Ez elősegíti a Web Tacho-ról való zökkenőmentesebb átállást, anélkül, hogy azonnali hitelvásárlásokra lenne szükség.",
    "current status": "Jelenlegi állapot",
    "Daily": "Napi",
    "data types": "Adattípusok",
    "deactivated": "Deaktiválva",
    "deactivated vehicle banner": {
      "description": "A jármű aktiválásáig nem foglal új krediteket, és a járműfájlok nem tölthetők le.",
      "link": "Jármű aktiválása",
      "title": "A jármű deaktiválva van"
    },
    "detailed speed": "Részletes sebesség",
    "details": "Részletek",
    "device imei": "Eszköz IMEI-száma",
    "device status": "Az eszköz állapota",
    "download status": "Letöltés állapota",
    "download time": "Letöltési idő",
    "DownloadPending": "Letöltés folyamatban",
    "driver": "Járművezető",
    "driver id": "Járművezető azonosítója",
    "driver status": "A járművezető állapota",
    "drivers": "Járművezetők",
    "edit": "Szerkesztés",
    "edit user": "Szerkesztés {{userEmail}}",
    "email limit reached": "Elérte a vállalat számára megengedett e-mailek maximális számát.",
    "email transfer": "E-mail-átvitel",
    "email transfer info tooltip": "Az e-mailes továbbítási funkció lehetővé teszi, hogy a letöltött tachográf-adatokat e-mailben kapja meg. A menetrend teljesítése után a rendszer automatikusan továbbítja az e-mailt a beállított címzetteknek. Minden vállalat legfeljebb {{maxCount}} e-mail-címzettet adhat hozzá.",
    "endpointUrl": "Végpont URL-je",
    "events and faults": "Események és hibák",
    "Every  days": "Minden {{count}} nap",
    "Every month": "Minden hónapban",
    "EveryDays": "Minden {{count}} nap",
    "Feature not available in BETA version": "A funkció a BETA verzióban nem elérhető",
    "file format": "Fájlformátum",
    "file sync": "Fájlok szinkronizálása",
    "general": "Általános",
    "host": "Hoszt",
    "imei": "IMEI",
    "included": "Tartalmazza",
    "integration method": {
      "Ftps": "FTPS",
      "Sftp": "SFTP",
      "Webhook": "Webhook"
    },
    "last activity": "Utolsó tevékenység",
    "last download attempt": "Utolsó letöltési kísérlet",
    "last successful download": "Utolsó sikeres letöltés",
    "Never": "Soha",
    "next download": "Következő letöltés",
    "next download attempt": "Következő letöltési kísérlet",
    "Next download attempt in  day": "Következő letöltési kísérlet {{count}} nap múlva",
    "Next download attempt in  days": "Következő letöltési kísérlet {{count}} nap múlva",
    "no company cards": "Nincs hozzáadott vállalati kártya.",
    "no driver schedule": "A járművezetőre nincs érvényes menetrend.",
    "no recipients added": "Nincs hozzáadott címzett",
    "no vehicle schedule": "A járműhöz nincs beállítva menetrend.",
    "not included": "Nem tartalmazza",
    "on next connection": "A következő csatlakozáskor",
    "open files": "Fájlok megnyitása",
    "open files disabled tooltip": "Ehhez az objektumhoz nincs elérhető fájl.",
    "other": "Egyéb",
    "overview": "Áttekintés",
    "parent company": "Anyavállalat",
    "password": "Jelszó",
    "port": "Port",
    "Quick schedule was completed": "A gyors ütemezés befejeződött",
    "remotePath": "Távoli könyvtár elérési útja",
    "remove": "Eltávolítás",
    "remove email recipient": {
      "description": "Biztosan el akarja távolítani ezt az e-mail címzettet? Ez a művelet visszafordíthatatlan.",
      "title": "Törölje a {{userEmail}}-t?"
    },
    "remove schedule": "Menetrend eltávolítása",
    "reserved": "Foglalt",
    "schedule details": "A menetrend részletei",
    "schedule history": "Menetrend-előzmények",
    "schedule start time": "A menetrend kezdési ideje",
    "schedules": "Menetrendek",
    "show less": "Kevesebbet mutat",
    "show more": "Továbbiak",
    "show older": "Régebbi eredmények megjelenítése",
    "status": "Állapot",
    "sub companies": "Leányvállalatok",
    "technical data": "Műszaki adatok",
    "Upon device connection": "Készüléken keresztüli kapcsolat",
    "username": "Felhasználónév",
    "users": "Felhasználók",
    "vehicles": "Járművek",
    "vrn": "VRN",
    "WaitingForDeviceConnection": "Várakozás az eszköz csatlakozására",
    "WaitingForScheduleStartTime": "Várakozás az ütemezés kezdési idejére"
  },
  "Dialog": {
    "account id": "Fiókazonosító",
    "account id cannot contain more than": "A fiókazonosító nem tartalmazhat {{maxNumber}} karakternél többet",
    "activate vehicles": {
      "description": "Az aktiválás után a járművek havi egyedi kapcsolati keret alapján igényelhetnek krediteket. Biztosan aktiválni szeretné a következő számú járművet?",
      "title": "Járművek aktiválása?"
    },
    "add": "Hozzáadás",
    "add company card": "Új vállalati kártya hozzáadása",
    "add driver": "Sofőr hozzáadása",
    "add integration": "Integráció hozzáadása",
    "add new integration": {
      "description": "Válassza ki a hozzáadni kívánt integráció típusát, majd a következő lépésben állítsa be a részleteket.",
      "title": "Új integráció hozzáadása"
    },
    "add vehicle": "Jármű hozzáadása",
    "add vehicle description": "Adjon hozzá járművet az összes regisztrációs adat kézi kitöltésével.",
    "add vehicle imei in use accessible": {
      "description": "Ez az IMEI-szám már egy másik járműhöz van társítva. Az újbóli hozzárendelés esetén az adott jármű le lesz választva a fájlletöltésekről. Biztosan folytatni szeretné?",
      "title": "Az IMEI már használatban van",
      "vehicle imei": "Az „{{imeiValue}}” IMEI-számmal rendelkező jármű:"
    },
    "all resource": "Minden {{resource}}",
    "api key": "API-kulcs",
    "api key placeholder": "API-kulcs megadása",
    "api key cannot contain more than": "Az API-kulcs nem tartalmazhat {{maxNumber}} karakternél többet",
    "api key edit": {
      "dialog title": "Az „{{keyName}}” API-kulcs szerkesztése",
      "success banner": "Az API-kulcs szerkesztése sikeresen megtörtént."
    },
    "api key name": "Kulcsszó",
    "api key name required": "A kulcs neve nem lehet üres",
    "api key name too long": "A kulcs neve nem tartalmazhat több mint {{maxNumber}} karaktert",
    "api management": {
      "description": "Hozzon létre API-kulcsot a rendszerünkhöz való API-hozzáférés biztonságos kezeléséhez, amely lehetővé teszi a saját szoftvereivel és munkafolyamataival való zökkenőmentes integrációt. A TachoSync API dokumentációja itt található ",
      "generated api key": "Létrehozott API-kulcs",
      "success banner": "Az API-kulcs létrehozása sikeresen megtörtént. Kérjük, feltétlenül mentse el az alábbi információkat, mivel azokat később már nem fogja tudni megtekinteni."
    },
    "cancel invitation": "Meghívás törlése",
    "cancel invitation description": "Biztosan törölni szeretné a {{userEmail}} meghívását?",
    "card holder name": "A kártyatulajdonos neve",
    "card holder name not valid": "A kártyatulajdonos neve nem tartalmazhat több mint {{maxNumber}} karaktert",
    "card holder name should not be empty": "A kártyatulajdonos neve nem lehet üres",
    "card holder name too short": "A kártyatulajdonos nevének legalább {{minNumber}} karaktert kell tartalmaznia",
    "card id not valid": "A kártya azonosítója legfeljebb {{maxNumber}} karaktert tartalmazhat",
    "card id should contain only digits, letters and hyphens": "A kártya azonosítója kizárólag számokat (0–9), A–F betűket és kötőjeleket (-) tartalmazhat.",
    "card id should contain only numbers": "A kártya azonosítója kizárólag számokat tartalmazhat",
    "card id should not be empty": "A kártya azonosítója nem lehet üres",
    "card id too short": "A kártya azonosítójának legalább {{minNumber}} karaktert kell tartalmaznia",
    "card name": "Kártya neve",
    "card name not valid": "A kártya neve nem tartalmazhat több mint {{maxNumber}} karaktert",
    "card name should not be empty": "A kártya neve nem lehet üres",
    "card name too short": "A kártya nevének legalább {{minNumber}} karaktert kell tartalmaznia",
    "choose period": "Időszak kiválasztása",
    "client company": "Ügyfélvállalat",
    "company": "Vállalat",
    "company card id": "Vállalati kártya azonosítója",
    "company name": "Cégnév",
    "company name in tachoSync": "Cégnév a TachoSync-ben",
    "company name placeholder": "Például: Teltonika Telematics",
    "company settings": {
      "allow credits overdraft": "Hitelkeret-túllépés engedélyezése",
      "auto add new drivers": "Új járművezetők automatikus regisztrációja",
      "auto add new drivers tooltip": "Amint a TachoSync felismer egy új sofőr-azonosítót, automatikusan hozzáadja azt a sofőrök táblázatához.",
      "auto assign global schedule to drivers": "Globális menetrend automatikus hozzárendelése új járművezetőkhöz",
      "auto assign global schedule to drivers tooltip": "Az újonnan regisztrált járművezetők esetében automatikusan alkalmazza a globális letöltési ütemtervet, így biztosítva az adatok letöltését manuális beavatkozás nélkül.",
      "auto assign global schedule to vehicles": "Globális ütemterv automatikus hozzárendelése az új járművekhez",
      "auto assign global schedule to vehicles tooltip": "Az újonnan regisztrált járművekre automatikusan alkalmazza a globális letöltési ütemtervet, így biztosítva az adatok letöltését manuális beavatkozás nélkül.",
      "auto download driver data": "A járművezető adatainak automatikus letöltése az első csatlakozáskor",
      "auto download driver data tooltip": "A rendszer automatikusan letölti a járművezető-kártya adatait, amikor a járművezető először csatlakozik. Ez biztosítja, hogy az új járművezetők esetében a menetrendek beállítása előtt a teljes előzményadatok rögzítésre kerüljenek.",
      "auto update vehicle registration number": "A jármű rendszámának (VRN) automatikus frissítése",
      "auto update vehicle registration number tooltip": "Ha ez az opció engedélyezve van, a jármű létrehozásakor megadott VRN-számot az első sikeres letöltés után a tachográf adataiból kiolvasott érték felülírja.",
      "automatic initial vehicle download": "A járműadatok automatikus letöltése az első csatlakozáskor",
      "automatic initial vehicle download tooltip": "A jármű első csatlakozásakor automatikusan letölti a jármű adatait. Ez biztosítja az új járművek teljes előzményeinek rögzítését a menetrendek beállítása előtt.",
      "title": "Vállalati beállítások"
    },
    "confirm add schedule": "Menetrend hozzáadása?",
    "confirm deactivate api key": {
      "description": "Biztosan le szeretné tiltani a „{{apiKeyName}}” API-kulcsot?",
      "title": "API-kulcs deaktiválása?"
    },
    "confirm deactivate integration": {
      "description": "Biztosan le szeretné tiltani a „{{integrationName}}” integrációt?",
      "title": "Az integrációt deaktiválni?"
    },
    "confirm delete analysis providers": "Biztosan törölni szeretné a következő számú elemzési szolgáltatót? Ez a művelet visszafordíthatatlan.",
    "confirm delete api credentials": "Biztosan törölni szeretné a kiválasztott API-hitelesítő adatokat? Ez a művelet visszafordíthatatlan, és az ezekkel a hitelesítő adatokkal végrehajtott API-hívások azonnal elutasításra kerülnek.",
    "confirm delete companies": "Biztosan törölni szeretné a kiválasztott vállalatot? Ez a művelet visszafordíthatatlan.",
    "confirm delete drivers": "Ezzel az összes járművezető-adat törlődik, de a járművezetői fájlok megmaradnak. Biztosan törölni szeretné a következő számú járművezetőt?",
    "confirm delete integrations": "Biztosan törölni szeretné a következő számú integrációt? Ez a művelet visszafordíthatatlan.",
    "confirm delete users": "Biztosan törölni szeretné a következő számú felhasználót? Ez a művelet visszafordíthatatlan.",
    "confirm delete vehicles": "Ezzel az összes járműadat törlődik, de a járműfájlok megmaradnak. Biztosan törölni szeretné a következő számú járművet?",
    "confirm empty imei": {
      "description": "Nem töltötte ki az IMEI mezőt. Az IMEI-kóddal nem rendelkező járművek nem tudnak csatlakozni a TachoSync-hez, és nem tudnak fájlokat letölteni.\nBiztosan folytatni szeretné?",
      "title": "Nincs hozzáadott IMEI"
    },
    "convey integration": {
      "add": {
        "description": "Konfigurálja a Convey-kapcsolatát",
        "title": "Convey integráció hozzáadása"
      },
      "edit": {
        "description": "Konfigurálja a Convey-kapcsolatát",
        "title": "Convey integráció szerkesztése"
      },
      "provider settings description": "Feltétlenül használja a Convey által megadott bejelentkezési adatokat.",
      "provider settings title": "Szolgáltatói beállítások"
    },
    "create": "Létrehozás",
    "create company": "Cég létrehozása",
    "create company main description": "Válassza ki, hogy új leányvállalatot szeretne létrehozni ebben a hierarchiában, vagy új ügyfelet szeretne létrehozni egy ügyfél-LZ-kód használatával.",
    "create new hierarchy": "Új hierarchia létrehozása",
    "create news": "Hír létrehozása",
    "create news description": "Röviden mutassa be a modál tartalmát.",
    "create quick schedule": "Gyors menetrend létrehozása",
    "create schedule": "Menetrend létrehozása",
    "create schedule description": "Állítsa be az automatikus fájlletöltéseket a dátum, az időpont és az ismétlődés kiválasztásával. A rendszer elvégzi a letöltéseket az Ön helyett, így manuális beavatkozás nélkül biztosítva a szabályoknak való megfelelést és az adatok pontosságát. A kezdési időpontot nem lehet a múltba állítani.",
    "credits history": {
      "description": "Kövesse nyomon aktuális egyenlegét, és tekintse meg a korábbi adatokat.",
      "description generate report": "Kövesse nyomon aktuális kreditegyenlegét, tekintse meg a korábbi adatokat, és készítsen „.csv” formátumú jelentést az elmúlt 12 hónapban felhasznált összes kreditről.",
      "generate report description": "Válasszon ki egy tetszőleges időszakot az elmúlt 12 hónapból, és készítsen jelentést a felhasznált kreditekről.",
      "generate report title": "Jelentés létrehozása",
      "title": "Hitelelőzmények"
    },
    "custom period": "Egyéni időszak",
    "date display format": "A dátum megjelenítési formátuma",
    "date range": "Időtartomány",
    "deactivate vehicle": "A jármű deaktiválása",
    "deactivate vehicle description": "A deaktivált járművek nem foglalnak le új krediteket, és letiltásra kerülnek az adatletöltés tekintetében",
    "deactivate vehicles": {
      "description": "A deaktivált járművek nem foglalnak le új krediteket, és letiltásra kerülnek az adatletöltés tekintetében.",
      "title": "Járművek deaktiválása?"
    },
    "delete": "Törlés",
    "delete analysis providers": "Elemzési szolgáltatók törlése?",
    "delete api credentials": "Törölni az API-hitelesítő adatokat?",
    "delete companies": "Cégek törlése?",
    "delete companies warning": "A vállalatok törlése művelet során az adott vállalatokhoz tartozó összes erőforrás törlésre kerül.",
    "delete drivers": "A járművezetők törlése?",
    "delete integrations": "Integrációk törlése?",
    "delete news": "Hír törlése?",
    "delete news description": "Biztosan törölni szeretné a kiválasztott híreket?",
    "delete unpublished release notes": "Törölje a még nem közzétett kiadási megjegyzéseket?",
    "delete unpublished release notes description": "Biztosan törölni szeretné a még nem közzétett kiadási megjegyzéseket?",
    "delete users": "Felhasználók törlése?",
    "delete vehicles": "Járművek törlése?",
    "description": "Leírás (opcionális)",
    "description not valid": "A leírás nem tartalmazhat több mint {{maxNumber}} karaktert",
    "description required": "Leírás",
    "description should not be empty": "A leírás nem lehet üres",
    "device imei": "Eszköz IMEI-száma",
    "dialog description": {
      "create company description": "A vállalati fa szerkezetében megengedett maximális vállalati szintszám: {{maxNumber}}.",
      "create new hierarchy description": "A vállalati fa struktúrában megengedett maximális vállalati szintek száma: {{maxNumber}}. Válassza ki, hogy új leányvállalatot szeretne létrehozni ebben a hierarchiában, vagy új ügyfelet szeretne létrehozni egy ügyfél-LZ-kód használatával."
    },
    "download activities": "Letöltési tevékenységek",
    "download blocked message": "A letöltés blokkolva van - a probléma megoldásához vegye fel a kapcsolatot szolgáltatójával.",
    "download data types": "Letölthető adattípusok",
    "download drivers files": "Illesztőprogramok letöltése",
    "download history dialog title": "{{vehicleNumber}} előzményei",
    "download monitoring dialog tooltip": "Az ebben a nézetben megjelenő összes adat <strong>10 másodpercenként</strong> automatikusan frissül.\nAz eszköz állapota az utolsó kapcsolatot tükrözi - nem a jármű aktuális állapotát.",
    "download only selection": "Csak a kiválasztott fájlok kerülnek letöltésre.",
    "download sample file message": "Töltse le a <1>CSV-sablont</1>, hogy megtekintse a szükséges formátum példáját.",
    "download status banners": {
      "CompanyCardExpired": "A vállalati kártya lejárt. Kérjük, adjon meg egy érvényes vállalati kártyát.",
      "InsufficientCredits": "Nincs elegendő kredit. Kérjük, töltsön fel krediteket a fájlok letöltéséhez.",
      "NoCompanyCards": "A letöltés megkezdéséhez a vállalati kártyának online állapotban kell lennie. Jelenleg nincs elérhető fájl.",
      "NoSchedulesApplied": "Ehhez a járműhöz nincs beállított menetrend.",
      "VehicleDeactivated": "Ez a jármű deaktiválva van, ezért nem indíthatja el a letöltési folyamatot."
    },
    "download status dialog title": "A {{vehicleNumber}} letöltésének figyelése",
    "download vehicles files": "Járműfájlok letöltése",
    "driver file destination": "A járművezető-fájlok célhelye",
    "driver file destination tooltip": "Válassza ki, hogy a járművezetői fájlokat a letöltés forrásául szolgáló jármű mappájába, vagy a járművezető azonosítója szerint létrehozott külön járművezetői mappákba kívánja-e menteni.",
    "driver folder": "Járművezetői mappa",
    "driver id": "Járművezető azonosítója",
    "driver id not valid": "A járművezető azonosítójának {{maxNumber}} alfanumerikus karaktert kell tartalmaznia",
    "driver id placeholder": "Például: 360896050032309",
    "driver id should not be empty": "A járművezető azonosítója nem lehet üres",
    "driver name": "A járművezető neve",
    "drivers folder naming": "A járművezetők mappáinak elnevezése",
    "edit company": "A „{{name}}” cég szerkesztése",
    "edit driver": "A „{{name}}” járművezető szerkesztése",
    "edit news": "Hír szerkesztése",
    "edit release notes tooltip": "Ezek a hírek kiadási megjegyzések formájában készülnek, és nem módosíthatók.",
    "edit user": "Felhasználó szerkesztése",
    "edit vehicle": "A „{{name}}” jármű szerkesztése",
    "edit vehicle imei in use accessible": {
      "description": "Ez az IMEI-szám már egy másik járműhöz van rendelve. Választhat, hogy kicseréli az IMEI-számokat a két jármű között, vagy felülírja az IMEI-számot.",
      "title": "Az IMEI már használatban van"
    },
    "email": "E-mail",
    "endpointUrl": "Végpont URL-je",
    "endpoint url": "Végpont URL-je",
    "endpoint url not valid": "A végpont URL-je érvénytelen",
    "endpoint url placeholder": "URL megadása",
    "enter": "Belépés",
    "enter company card id": "Kérjük, adja meg a Company Card Authenticator alkalmazásban található vállalati kártya azonosítóját.",
    "enter here": "Itt lépjen be",
    "enter name": "Írja be a nevet",
    "enter password": "Jelszó megadása",
    "enter username": "Adja meg a felhasználónevet",
    "expiration date optional": "Lejárati dátum (opcionális)",
    "export drivers": {
      "description": "A kiválasztott vállalat összes járművezetőjének adatait exportálja a kívánt .csv fájlokba.",
      "include drivers from all companies": "Minden vállalat sofőrjeinek bevonása",
      "title": "Sofőrök exportálása"
    },
    "export vehicles": {
      "description": "A kiválasztott vállalat összes járművét exportálja a kívánt .csv fájlokba.",
      "include vehicles from all companies": "Minden vállalat járműveinek felvétele",
      "title": "Járművek exportálása"
    },
    "feature switches": {
      "feature switches": "Funkciókapcsolók",
      "toggle integrations page": "Integrációk engedélyezése oldal"
    },
    "field cannot be changed": "Ez a mező nem módosítható",
    "field cannot be empty": "A {{fieldName}} nem lehet üres",
    "field length not valid": "Ez a mező legfeljebb {{maxNumber}} karaktert tartalmazhat",
    "file format": "Fájlformátum",
    "filtered resource": "Szűrt {{resource}}",
    "filtered drivers": "Szűrt járművezetők",
    "filtered vehicles": "Szűrt járművek",
    "from": "Forrás:",
    "future dates": {
      "1 day": "1 nap múlva",
      "1 minute": "1 perc múlva",
      "1 month": "1 hónap múlva",
      "1 week": "1 hét múlva",
      "1 year": "1 év múlva",
      "hours and minutes": "{{hourCount}} óra {{minutesCount}} perc múlva",
      "less than a minute": "<1 percen belül",
      "multiple days": "{{daysCount}} nap múlva",
      "multiple minutes": "{{minutesCount}} perc múlva",
      "multiple months": "{{monthsCount}} hónap múlva",
      "multiple weeks": "{{weeksCount}} hét múlva",
      "multiple years": "{{yearsCount}} év múlva"
    },
    "generate api key": {
      "title": "API-kulcs generálása"
    },
    "host": "Hoszt",
    "host cannot contain more than": "A gazdagép neve nem tartalmazhat több mint {{maxNumber}} karaktert",
    "imei": "IMEI",
    "imei not valid": "Az IMEI-számnak {{maxNumber}} számjegyből kell állnia",
    "imei placeholder": "Például: 360896050032309",
    "imei should not be empty": "Az IMEI mező nem lehet üres",
    "import drivers": "Sofőrök importálása",
    "import drivers description": "Fájlból importálva adhatja hozzá a járművezetőket a listájához.",
    "import vehicles": "Járműimport",
    "import vehicles description": "Adjon hozzá járműveket a listájához egy fájlból történő importálással.",
    "integration name": "Integráció neve",
    "integration type": "Integrációs típus",
    "integrations": {
      "deactivate api key": "API-kulcs deaktiválása",
      "deactivate sftp": "SFTP letiltása",
      "deactivate integration tooltip": "Az integrációt ideiglenesen deaktiválja. Az opció jelölésének eltávolításával újra aktiválhatja.",
      "deactivate integration": {
        "title": "Az integráció deaktiválása",
        "tooltip": "Az integrációt ideiglenesen deaktiválja. Az opció jelölésének eltávolításával újra aktiválhatja."
      },
      "disable integration": {
        "description": "Biztosan le szeretné tiltani a „{{integrationName}}” integrációt?",
        "title": "Az integrációt letiltani?"
      },
      "driver files info banner": "Felhívjuk figyelmét, hogy a {{formattedDate}} előtt letöltött járművezetői fájlok a járművezető által legutóbb vezetett jármű mappájába kerülnek. ",
      "errors": {
        "AuthenticationFailed": {
          "description": "Kérjük, ellenőrizze, hogy a felhasználónevet és a jelszót helyesen adta-e meg.\nAz integráció addig „Sikertelen” állapotban marad, amíg a helyes hitelesítő adatokat meg nem adja.",
          "title": "Helytelen bejelentkezési adatok."
        },
        "FolderCreationFailed": {
          "description": "A TachoSync csatlakozott a szerverhez, de nincs jogosultsága mappák létrehozására vagy fájlok feltöltésére a célmappába.\nAz integráció „Sikertelen” állapotban marad, amíg a probléma megoldásra nem kerül, és újra nem próbálja meg a csatlakozást.",
          "title": "Írási jogosultság hiányzik."
        },
        "HostUnreachable": {
          "description": "Kérjük, ellenőrizze, hogy a szerver címe és portja helyes-e, valamint hogy a szerver elérhető-e.\nAz integráció „Sikertelen” állapotban marad, amíg a probléma megoldásra nem kerül, és Ön újra nem próbálja meg a csatlakozást.",
          "title": "A szerver nem érhető el."
        },
        "PathNotFound": {
          "description": "A megadott könyvtár nem található a szerveren. Kérjük, ellenőrizze, hogy az elérési út helyes-e.\nAz integráció „Sikertelen” állapotban lesz elmentve, amíg helyes elérési utat nem ad meg.",
          "title": "Az útvonal nem található."
        },
        "PermissionDenied": {
          "description": "Kérjük, győződjön meg arról, hogy a TachoSync rendelkezik a szükséges jogosultságokkal az adott útvonal eléréséhez.\nAz integráció „Sikertelen” állapotban marad, amíg a jogosultságokat frissítik, és újra megpróbálja a csatlakozást.",
          "title": "Az elérési útvonalhoz való hozzáférés megtagadva."
        },
        "Unknown": {
          "description": "Váratlan hiba történt az SFTP-kiszolgálóhoz való csatlakozás során. Kérjük, ellenőrizze a kiszolgáló adatait és beállításait.\nAz integráció „Sikertelen” állapotban marad, amíg a probléma megoldásra nem kerül, és újra nem próbálja meg a csatlakozást.",
          "title": "Váratlan hiba történt."
        }
      },
      "include files from all sub companies": "Az összes leányvállalat fájljainak bevonása",
      "include files tooltip": "Ha ezt az integrációt választja, akkor a rendszer az Ön fiókjához tartozó összes leányvállalattól is letölti a fájlokat",
      "include historical files": "A korábbi fájlok bevonása",
      "include historical files tooltip": "Ha ezt a beállítást választja, az integráció létrehozása előtt letöltött fájlok is beolvasásra kerülnek.",
      "select driver files destination": "Válassza ki a járművezetői fájlok célhelyét"
    },
    "introduce name": "Név megadása",
    "invite user": "Felhasználó meghívása",
    "invite user description": "A meghívó elküldése után a felhasználó \ne-mailt kap egy fiók létrehozására szolgáló linkkel. A link 7 napig érvényes.",
    "invite user sent": "A felhasználói meghívó sikeresen elküldve.",
    "loading": "Betöltés...",
    "make release notes": "Készítsen kiadási megjegyzéseket",
    "make release notes info": "Ha ezt a mezőt bejelöli, a hír megjelenik a Kiadási megjegyzésekben, és a cím Kiadási megjegyzésekre változik.",
    "max download files": "Egy letöltési művelet során megengedett maximális fájlszám: {{maxNumber}}.",
    "move company": {
      "confirmation dialog": {
        "are you sure": "Biztos benne?",
        "description": "A „{{sourceCompany}}” vállalatot a „{{targetCompany}}” vállalatba készül áthelyezni. Ez a művelet visszafordíthatatlan, biztosan folytatni szeretné?"
      },
      "description": "Válasszon ki egy forrásvállalatot és egy célvállalatot, amelyhez át szeretné helyezni. A forrásvállalat és erőforrásai a kiválasztott célvállalat alá kerülnek. Ez a művelet visszafordíthatatlan.",
      "error dialog": {
        "description": "A megengedett vállalati szintek maximális száma 4. A kiválasztott vállalat ide történő áthelyezése túllépné ezt a határt.",
        "title": "A vállalat áthelyezése nem lehetséges"
      },
      "info banner": "A forrásvállalat megtartja az összes járművét, sofőrjét, fájljait, vállalatait, felhasználóit, integrációit és egyedi menetrendjeit. Ha a gyökérvállalati szinten globális menetrend van engedélyezve, az áthelyezés után az átöröklődik. Ha nem, a meglévő menetrendek változatlanul megmaradnak.",
      "source company": "Forrásvállalat",
      "sftp warning": "A kiválasztott vállalatnál egy aktív SFTP-kiszolgáló van beállítva. Az SFTP-kapcsolat a vállalat áthelyezése alatt szünetel. Az áthelyezés befejezése után új SFTP-útvonal jön létre, és a kapcsolat újraindul.",
      "target company": "Célvállalat",
      "title": "Cég áthelyezése"
    },
    "move vehicles": "Járművek mozgatása",
    "move vehicles info": "Megjegyzés: A járműfájlok a jelenlegi vállalatnál maradnak. A letöltési előzmények törlődnek, és a letöltési ütemezések is eltávolításra kerülnek.",
    "name": "Név",
    "name not valid": "A név nem tartalmazhat több mint {{maxNumber}} karaktert",
    "name should not be empty": "A név mező nem maradhat üres",
    "name too short": "A névnek legalább {{minNumber}} karaktert kell tartalmaznia",
    "optional": "opcionális",
    "overwrite imei checkbox": {
      "description": "Ez az opció eltávolítja az IMEI-t a {{vehicleNumber}}-ból.",
      "title": "IMEI felülírása."
    },
    "parent company": "Anyavállalat",
    "password": "Jelszó",
    "password cannot contain more than": "A jelszó nem tartalmazhat több mint {{maxNumber}} karaktert",
    "past dates": {
      "1 month ago": "1 hónappal ezelőtt",
      "1 week ago": "1 héttel ezelőtt",
      "1 year ago": "1 évvel ezelőtt",
      "multiple months ago": "{{monthCount}} hónappal ezelőtt",
      "multiple weeks ago": "{{weekCount}} héttel ezelőtt",
      "multiple years ago": "{{yearCount}} évvel ezelőtt",
      "today": "Ma",
      "yesterday": "Tegnap"
    },
    "port": "Port",
    "port must be between": "A port értékének a {{minNumber}} és a {{maxNumber}} értékek között kell lennie",
    "previous month": "Előző hónap",
    "provider": "Szolgáltató",
    "publish news": "Hírt szeretne közzétenni?",
    "publish news description": "Ez a hír közzétételre van beállítva. Biztosan folytatni szeretné? Ez a művelet visszafordíthatatlan.",
    "publish release notes": "Közzé kell tenni a kiadási megjegyzéseket?",
    "publish release notes description": "A kiadási megjegyzések közzétételre kerülnek. Biztosan folytatni szeretné? Ez a művelet visszafordíthatatlan.",
    "release notes": "Kiadási megjegyzések",
    "remote directory path cannot contain more than": "A távoli könyvtár elérési útja nem tartalmazhat több mint {{maxNumber}} karaktert",
    "remote directory path optional": "Távoli könyvtár elérési útja (opcionális)",
    "remove": "Eltávolítás",
    "remove schedules": "Menetrendek eltávolítása",
    "remove schedules confirmation description": {
      "drivers multiple": "Biztosan el akarja távolítani a {{resourceValue}} menetrendeket a kiválasztott járművezetőknél?",
      "drivers single": "Biztosan el akarja távolítani a {{resourceValue}}-t a kiválasztott járművezetőktől?",
      "vehicles multiple": "Biztosan el akarja távolítani a {{resourceValue}} menetrendeket a kiválasztott járművekről?",
      "vehicles single": "Biztosan el akarja távolítani a {{resourceValue}}-t a kiválasztott járművekből?"
    },
    "remove schedules description": {
      "drivers": "Válasszon ki egy vagy több menetrendet, amelyet el szeretne távolítani a kiválasztott járművezetők adataiból.",
      "vehicles": "Válasszon ki egy vagy több menetrendet, amelyet el szeretne távolítani a kiválasztott járművekről."
    },
    "resend invitation": "Meghívó újraküldése",
    "resend invitation description": "Biztosan újra szeretné elküldeni a meghívót a {{userEmail}}-ra?",
    "role": "Feladat",
    "schedule apply to all": {
      "drivers": "A kiválasztott ütemterv a kiválasztott vállalat összes járművezetőjére vonatkozik.",
      "vehicles": "A kiválasztott ütemterv a kiválasztott vállalat összes járművére vonatkozik."
    },
    "schedule apply to filtered": {
      "drivers": "A kiválasztott ütemezés az egy vagy több rendelkezésre álló szűrő segítségével kiszűrt járművezetőkre lesz alkalmazva.",
      "vehicles": "A kiválasztott ütemezés az egy vagy több rendelkezésre álló szűrő segítségével kiszűrt járművekre lesz alkalmazva."
    },
    "schedule apply to selected": {
      "drivers": "A kiválasztott ütemterv a jelölőnégyzet segítségével az összes kiválasztott járművezetőre vonatkozik.",
      "vehicles": "A kiválasztott ütemezés a jelölőnégyzet segítségével kiválasztott összes járműre vonatkozik."
    },
    "schedule time tooltip description": "Ha a kiválasztott időpont a múltban van, a rendszer automatikusan a legközelebbi elérhető jövőbeli időpontra állítja át.",
    "security settings": "Biztonsági beállítások",
    "security settings description": "Keresse meg azokat a beállításokat, amelyekkel szabályozhatja fiókja védelmét.",
    "select": "Kiválasztás",
    "select a company": "Válasszon ki egy vállalatot",
    "select file format example": "Válassza ki a formátumot (pl. .DDD)",
    "select format": "Formátum kiválasztása",
    "select image": "Kép kiválasztása",
    "select image description": "Válassza ki a használni kívánt képet úgy, hogy rákattint, majd megnyomja a Mentés gombot.",
    "select schedules": "Menetrendek kiválasztása",
    "selected resource": "Kiválasztott {{resource}}",
    "selected drivers": "Kiválasztott járművezetők",
    "selected vehicles": "Kiválasztott járművek",
    "selected role info message": "<3>Kattintson ide</3> a jogosultságok részletes táblázatának megtekintéséhez.",
    "selected role info message title": "A szerepkör határozza meg a felhasználók jogosultságait a TachoSync rendszerben.",
    "sftp integration": {
      "description": "Konfigurálja az SFTP-kapcsolatot, és határozza meg a tachográf-fájlok felépítését.",
      "edit title": "SFTP-integráció szerkesztése „{{integrationName}}”",
      "sftp name": "SFTP-név",
      "title": "SFTP-integráció"
    },
    "sftp password": "SFTP jelszó",
    "sftp server hostname or ip": "SFTP-kiszolgáló hosztneve vagy IP-címe",
    "sftp server port number": "SFTP-kiszolgáló portszáma",
    "sftp server settings": "SFTP-kiszolgáló beállításai",
    "sftp username": "SFTP felhasználónév",
    "Teltonika code": "Teltonika kód",
    "Teltonika code invalid characters": "A Teltonika kódnak {{minCount}}–{{maxCount}} karakter hosszúnak kell lennie, és tartalmazhat betűket, számokat és pontokat.",
    "Teltonika code placeholder": "A Teltonika kódnak {{minCount}}-{{maxCount}} karakterből kell állnia",
    "Teltonika company name": "Cégnév",
    "time": "Idő",
    "time zone": "Időzóna",
    "title": "Cím",
    "title not valid": "A cím nem tartalmazhat több mint {{maxNumber}} karaktert",
    "title should not be empty": "A cím nem lehet üres",
    "title too short": "A címnek legalább {{minNumber}} karaktert kell tartalmaznia",
    "to": "Címzett",
    "toggle children global schedule linking": "Kapcsolat az anyavállalattal Globális ütemterv",
    "toggle children global schedule linking tooltip": "A gyökérvállalat engedélyezte a globális ütemterv öröklődését. A kiválasztott vállalat globális ütemtervének szerkesztéséhez tiltsa le ezt az opciót. Vegye figyelembe, hogy ezzel a globális ütemterv elválik a gyökérvállalattól.",
    "toggle global schedule linking": "A globális ütemterv alkalmazása az összes leányvállalatra",
    "toggle global schedule linking tooltip": "Ennek az opciónak az engedélyezése esetén a globális ütemterv minden leányvállalatra érvényes lesz. A leányvállalatok letilthatják ezt az opciót, hogy saját globális ütemtervüket testre szabhassák.",
    "toggle global schedule warning banner": "Előfordulhat, hogy egyes leányvállalatok máris más globális ütemtervet használnak. Ez az opció nem érinti őket, hacsak nem választják ki a globális ütemterv beállításaiban.",
    "unpublished release notes": "Vannak még nem közzétett kiadási megjegyzések.",
    "upload folder blank for root": "Feltöltési mappa (a gyökérkönyvtár esetében üres)",
    "username": "Felhasználónév",
    "username cannot contain more than": "A felhasználónév nem tartalmazhat több mint {{maxNumber}} karaktert",
    "vdo integration": {
      "add": {
        "description": "Állítsa be a VDO flottakapcsolatát.",
        "title": "VDO flotta-integráció hozzáadása"
      },
      "edit": {
        "description": "Állítsa be a VDO flottakapcsolatát.",
        "title": "VDO flottaintegráció szerkesztése"
      },
      "provider settings description": "Feltétlenül használja a VDO Fleet által megadott bejelentkezési adatokat.",
      "provider settings title": "Szolgáltatói beállítások"
    },
    "vehicle folder": "Járműmappa",
    "vehicle imei in use inaccessible": {
      "description": "Ez az IMEI-szám már egy, az Ön vállalatcsoportján kívüli vállalathoz van rendelve. Ha az ezen IMEI-számmal rendelkező eszköz az Ön tulajdonában van, kérjük, vegye fel a kapcsolatot <supportLink>a Teltonika ügyfélszolgálatával</supportLink>.",
      "title": "Egy másik vállalatcsoport által használt IMEI"
    },
    "vehicle name": "Jármű neve",
    "vehicle number": "Jármű rendszáma (VRN)",
    "vehicle registration number tooltip": "Az automatikus frissítés engedélyezve van a vállalati beállításokban. Az itt megadott VRN-számot az első sikeres letöltés után a tachográf adataiból kiolvasott érték felülírja.",
    "vehicles folder naming": "Járműmappa elnevezés",
    "vrn": "VRN",
    "vrn should not be empty": "A jármű rendszáma nem lehet üres",
    "welcome to beta version title": "Üdvözöljük a TachoSync BETA tesztelésén!"
  },
  "Download history": {
    "download successful": "A letöltés sikeresen megtörtént",
    "driver data": "Járművezetői adatok",
    "no history": "Az előzmények itt jelennek meg",
    "schedule": "Ütemezés"
  },
  "Download monitoring": {
    "APDU packet reading error. Device disconnected.": "APDU-csomag olvasási hiba. Az eszköz kapcsolata megszakadt.",
    "Authenticating": "Hitelesítés",
    "Authentication failure (02x10)": "Hitelesítési hiba (02x10)",
    "Authentication failure after timeout (02x01)": "Hitelesítési hiba időtúllépés után (02x01)",
    "Authentication failure after timeout (02x12)": "Hitelesítési hiba időtúllépés után (02x12)",
    "Card reading error. Please reinsert the company card, reconnect the card reader, or restart the service.": "Kártyaolvasási hiba. Kérjük, helyezze vissza a vállalati kártyát, csatlakoztassa újra a kártyaolvasót, vagy indítsa újra a szolgáltatást.",
    "CheckingCredits": "Kreditek ellenőrzése",
    "CompanyCardExpired": "A vállalati kártya lejárt",
    "CompanyCardInUse": "Céges kártya használata",
    "Could not download any of files": "Egyetlen fájlt sem sikerült letölteni",
    "CreditReserved": "Jog fenntartva",
    "Download rejected: device VIN doesn't match this vehicle's VIN record. If the device was moved to a new vehicle, create a new vehicle record to continue.": "A letöltés sikertelen: az eszköz alvázszáma nem egyezik meg a jármű alvázszámával. Ha az eszközt új járműbe szerelték be, hozzon létre egy új járműrekordot a folytatáshoz.",
    "DownloadingDriverData": "A járművezetői adatok letöltése",
    "DownloadingDriverDataFailed": "A sofőradatok letöltése sikertelen",
    "DownloadingVehicleData": "Járműadatok letöltése",
    "Driver info packet reading error. Device disconnected.": "Hiba a járművezető-adatcsomag olvasásakor. Az eszköz kapcsolata megszakadt.",
    "Failed to download driver data": "A járművezető-adatok letöltése nem sikerült",
    "Failed to receive APDU from card, timeout exceeded": "Nem sikerült fogadni az APDU-t a kártyáról, lejárt az időkorlát",
    "Failed to receive VUReady packet from device, timeout exceeded": "Nem sikerült fogadni a VUReady csomagot az eszközről, a várakozási idő lejárt",
    "Failed to receive VUReady packet. If problem persists, check the telematics/tacho devices setup.": "A VUReady-csomag fogadására nem került sor. Ha a probléma továbbra is fennáll, ellenőrizze a telematikai/tachográf-eszközök beállításait.",
    "InsufficientCredits": "Nincs elegendő kredit",
    "Lost connection with device or card": "Megszakadt a kapcsolat az eszközzel vagy a kártyával",
    "NoCompanyCards": "Nincs vállalati kártya",
    "NoDueSchedules": "Nincs esedékességi ütemterv",
    "NoSchedulesApplied": "Nincs alkalmazott ütemterv",
    "ProcessTerminated": "A folyamat leállt",
    "ReceivingDownloadList": "Letöltési lista fogadása",
    "ReceivingDriverInfo": "A járművezetői adatok fogadása",
    "ReceivingDriversSchedules": "A járművezetők menetrendjeinek fogadása",
    "ReceivingStatusState": "Átvételi állapot",
    "ReceivingVehicleSchedules": "Járműmenetrendek fogadása",
    "requirements": {
      "company card": "Céges kártya",
      "credits available": "Rendelkezésre álló kreditek",
      "ignition": "Gyújtás",
      "ignition unavailable tooltip": "Ismeretlen - az utolsó ismert állapot több mint 2 órával ezelőtt volt.",
      "imei": "IMEI",
      "schedule assigned": "Beosztás hozzárendelve",
      "vehicle activated": "Jármű által aktivált",
      "reason": {
        "CompanyCardExpired": "A vállalati kártya lejárt",
        "IgnitionNotReportedRecently": "Ismeretlen állapot - a gyújtás állapotáról nem érkezett friss jelentés. A letöltés megkísérelésre kerül, de a siker valószínűsége alacsonyabb",
        "IgnitionOff": "A gyújtás ki van kapcsolva. A letöltés megkísérelésre kerül, de a siker valószínűsége alacsonyabb",
        "InsufficientCredits": "Nincs rendelkezésre álló kredit",
        "NoCompanyCardOnline": "Jelenleg nincs online vállalati kártya",
        "NoCompanyCards": "Jelenleg nincs online vállalati kártya",
        "NoImeiAssigned": "A járműhöz nincs hozzárendelt IMEI-szám",
        "NoScheduleAssigned": "A járműhöz menetrendet kell rendelni",
        "VehicleDeactivated": "Az adatok letöltéséhez a járművet aktiválni kell"
      }
    },
    "schedules": {
      "assign schedules": "Menetrendek hozzárendelése",
      "assign schedules dialog": {
        "description": "Válasszon ki egy vagy több ütemezést, amelyet hozzárendelni szeretne.",
        "title": "Menetrendek hozzárendelése a {{vehicleNumber}}-hoz"
      },
      "fail reason": {
        "download requirements not met": "a letöltési követelmények nem teljesültek."
      },
      "no schedules assigned": "Ehhez a járműhöz nincs hozzárendelt menetrend",
      "on device connection": "az eszköz csatlakozásakor",
      "requirements not met": "A menetrend addig nem hajtható végre, amíg minden követelmény nem teljesül."
    },
    "StageComplete": "Lépés befejezve",
    "Stages": {
      "Authentication": "Hitelesítés",
      "Downloading": "Letöltés",
      "DownloadTrigger": "Letöltés indítása",
      "Initialization": "Inicializálás"
    },
    "Status packet reading error. Device disconnected.": "Hibás állapotcsomag-olvasás. Az eszköz kapcsolata megszakadt.",
    "TerminatingConnectionToDevice": "A készülékkel való kapcsolat megszüntetése",
    "Timeout. Response from VU not received (02x01)": "Időtúllépés. A járműegységtől nem érkezett válasz (02x01)",
    "Too many KeepAlive packets received.": "Túl sok KeepAlive-csomag érkezett.",
    "Unexpected error": "Váratlan hiba",
    "Unexpected loss of connection with the device. Once device returns to normal connectivity, download will continue.": "Váratlan kapcsolatmegszakadás az eszközzel. Amint az eszköz újra normál kapcsolatot létesít, a letöltés folytatódik.",
    "UploadingDriverFiles": "Járművezetői fájlok feltöltése",
    "UploadingDriverFilesFailed": "A járművezetői fájlok feltöltése sikertelen volt",
    "UploadingVehicleFiles": "Járműfájlok feltöltése",
    "UploadingVehicleFilesFailed": "A járműfájlok feltöltése sikertelen volt",
    "VehicleDeactivated": "Jármű deaktiválva",
    "VuNotReady": "A jármű még nem áll készen. 5 perc múlva újra próbálom.",
    "VU ready packet reading error. Device disconnected.": "VU-kompatibilis csomagolvasási hiba. Az eszköz kapcsolata megszakadt.",
    "WaitingForDeviceConnection": "Várakozás az eszköz csatlakozására",
    "Wrong communication command": "Helytelen kommunikációs parancs"
  },
  "Drivers": {
    "drivers page": "Járművezetők",
    "last activity": {
      "Available": "Elérhető",
      "BreakOrRest": "Szünet/Pihenő",
      "Drive": "Vezetés",
      "NotAvailable": "Nem elérhető",
      "Undefined": "N/A",
      "Unknown": "Ismeretlen",
      "Unknown4": "Ismeretlen",
      "Unknown5": "Ismeretlen",
      "Work": "Munka"
    }
  },
  "Dropzone": {
    "add file": "Fájl hozzáadása",
    "drop file to upload": "Húzza ide a fájlt a feltöltéshez",
    "drop files to upload": "Fájlok feltöltéséhez húzza őket ide",
    "error uploading the file": "Hiba történt a fájl feltöltése közben",
    "file invalid type": "Érvénytelen fájltípus lett kiválasztva.",
    "file successfully uploaded": "A fájl feltöltése sikeresen megtörtént",
    "file syntax": "A fájlok szintaxisa a következő:",
    "maximum file limit reached": "Elérte a maximális fájlméret-korlátot.",
    "no image": "Nincs kép",
    "only one file can be attached": "Csak egy fájl csatolható.",
    "or drop file to upload": "Vagy húzza ide a fájlt a feltöltéshez",
    "or drop files to upload": "Vagy húzza ide a fájlokat a feltöltéshez",
    "row limit exceeded": "Elérte az erőforrás-import korlátját. Legfeljebb {{rowLimit}} erőforrást importálhat.",
    "rows detected": "A fájl sorait sikeresen azonosítottuk",
    "select file": "Fájl kiválasztása",
    "select file type": "Kérjük, először válassza ki a fájltípust.",
    "select files": "Fájlok kiválasztása",
    "select image": "Kép kiválasztása:",
    "supported formats": "Támogatott formátumok",
    "too long file name": "A fájlnév túl hosszú. Legfeljebb {{maxLength}} karakter megengedett.",
    "too many files description": "A többi fájlt a kiválasztott fájlok feltöltése után töltheti fel.",
    "too many files title": "Egyszerre legfeljebb {{maxFiles}} fájlt csatolhat."
  },
  "Error": {
    "error": "Hiba",
    "message wait": "Kérjük, legyen türelmes, amíg kijavítjuk a hibát.",
    "title": "Valami hiba történt!"
  },
  "Files": {
    "files header info tooltip": "A letöltött fájlok két évig tárolódnak a TachoSync-ben, majd ezt követően automatikusan eltávolításra kerülnek a rendszerből."
  },
  "Filter": {
    "company": "Vállalat",
    "credit status": "Hitelképesség",
    "deactivatedVehicles": "Kikapcsolt járművek",
    "device imei": "Eszköz IMEI-száma",
    "device status": "Az eszköz állapota",
    "driver": "Járművezető",
    "filtered by": "Szűrés",
    "filters used": "Használt szűrők",
    "from to date": "{{fromDate}} – {{toDate}}",
    "last activity": "Utolsó tevékenység",
    "last download": "Utolsó letöltés",
    "last download options": {
      "DueSoon": "Hamarosan esedékes",
      "NoDownloads": "Nincs letöltés",
      "OnTime": "Időben",
      "Overdue": "Késedelmes",
      "Undefined": "N/A"
    },
    "more filters": "További szűrők",
    "noDeviceImei": "Nincs eszköz IMEI-száma",
    "Not reserved": "Nincs lefoglalva",
    "Reserved": "Foglalt",
    "schedule": "Ütemezés",
    "schedule name": "Ütemezés neve",
    "schedules": "Menetrendek",
    "select date": "Dátum kiválasztása",
    "select date and time": "Válassza ki a dátumot és az időpontot",
    "Select date range": "Dátumtartomány kiválasztása",
    "status": "Állapot",
    "table filters": "Táblázatszűrők",
    "vehicle number": "Járműszám"
  },
  "General": {
    "Active": "Aktív",
    "Administrator": "Rendszergazda",
    "administrator role description": "Teljes hozzáférés az összes erőforrás létrehozásához, szerkesztéséhez és törléséhez.",
    "analysis provider": "Elemzési szolgáltató",
    "analysis providers": "Elemzési szolgáltatók",
    "api credential": "API-hitelesítő adatok",
    "api credentials": "API-hitelesítő adatok",
    "Available": "Elérhető",
    "Awaiting connection": "Kapcsolatra vár",
    "badge": {
      "connected badge tooltip text": "Sikeresen csatlakozott a TachoSync-hez, és aktívan kommunikál.",
      "deactivated badge tooltip text": "Ez a jármű deaktiválva van, és nem fog krediteket felhasználni.",
      "inactive badge tooltip text": "Soha nem sikerült kapcsolatot létesíteni a TachoSync alkalmazással.",
      "offline badge tooltip text": "Az elmúlt 24 órában nem csatlakozott a TachoSync-hez",
      "online badge tooltip text": "Az elmúlt 24 órában csatlakozott"
    },
    "Blocked": "Letiltva",
    "BreakOrRest": "Szünet/Pihenő",
    "business": "Üzleti",
    "code expired": "A bejelentkezési munkamenet lejárt. Kérjük, jelentkezzen be újra.",
    "column": "Oszlop",
    "companies": "Vállalatok",
    "company": "Vállalat",
    "Company administrator": "Cégadminisztrátor",
    "Connected": "Csatlakoztatott",
    "credits": "Kreditek",
    "dashboard": "Műszerfal",
    "Deactivated": "Deaktiválva",
    "Description": "Leírás",
    "Disabled": "Letiltva",
    "Disconnected": "Nincs kapcsolat",
    "Drive": "Vezetés",
    "driver data": "Járművezetői adatok",
    "drivers": "Járművezetők",
    "DueSoon": "Hamarosan esedékes",
    "end": "Vége",
    "Expired": "Lejárt",
    "Failed": "Hiba",
    "files": "Fájlok",
    "here": "itt",
    "history": "Előzmények",
    "Inactive": "Inaktív",
    "in progress": "folyamatban",
    "integration": "Integráció",
    "integrations": "Integrációk",
    "integrations/analysisProviders": "Elemzési szolgáltatók",
    "integrations/apicredentials": "API-hitelesítő adatok",
    "Interrupted": "Megszakítva",
    "InvalidConfiguration": "Hiba",
    "invitations": "Meghívók",
    "latest version": "Legújabb verzió",
    "menu": "Menü",
    "NoDownloads": "Nincs letöltés",
    "not assigned": "Nincs hozzárendelve",
    "Not reserved": "Nincs lefoglalva",
    "NotAvailable": "Nem elérhető",
    "NotReserved": "Nincs lefoglalva",
    "Offline": "Offline",
    "Online": "Online",
    "OnTime": "Időben",
    "Pending": "Függőben",
    "requirements": "Követelmények",
    "Reserved": "Foglalt",
    "row": "Sor",
    "schedule": "Ütemezés",
    "schedules": "Menetrendek",
    "show older": "Régebbi eredmények megjelenítése",
    "start": "Kezdés",
    "Successful": "Sikeres",
    "Teltonika support": "Teltonika ügyfélszolgálat",
    "Teltonika Support": "Teltonika ügyfélszolgálat",
    "teltonika support role description": "Speciális hozzáférés a technikai támogatáshoz.",
    "Tooltip": {
      "accept beta terms": "A folytatáshoz görgessen az oldal aljára, és fogadja el a feltételeket."
    },
    "unauthorized": "A felhasználó hitelesítése nem sikerült",
    "Undefined": "N/A",
    "Unknown": "Ismeretlen",
    "Unknown4": "Ismeretlen",
    "Unknown5": "Ismeretlen",
    "User": "Felhasználó",
    "user role description": "Alapvető hozzáférés korlátozott jogosultságokkal.",
    "users": "Felhasználók",
    "vehicles": "Járművek",
    "Work": "Munka",
    "year": "Év"
  },
  "Languages": {
    "english": "angol",
    "french": "francia",
    "language": "Nyelv"
  },
  "Navigation": {
    "collapse menu": "Menü bezárása",
    "expand menu": "Menü kibontása"
  },
  "News": {
    "create news": "Hír létrehozása",
    "delete": "Törlés",
    "edit": "Szerkesztés",
    "publish": "Közzététel",
    "unpublished": "Még nem jelent meg"
  },
  "Notifications": {
    "notifications": "Értesítések"
  },
  "Password": {
    "account password": "Fiók jelszava",
    "are you sure": "Biztos benne?",
    "change": "Módosítás",
    "change password": "Jelszó módosítása",
    "click to scan code": "Kattintson ide, ha inkább QR-kódot szeretne beolvasni",
    "click to type code": "Kattintson ide, ha a kódot inkább kézzel szeretné beírni",
    "disable description confirmation": "A kétfaktoros hitelesítést hamarosan letiltja. Ez veszélybe sodorhatja a TachoSync-fiókja biztonságát. Biztosan folytatni szeretné?",
    "disable description send code": "Egy 6 számjegyű kódot küldtünk az azonosító alkalmazásába. Biztonsági okokból kérjük, írja be a generált kódot az alábbi mezőbe.",
    "disable description send password": "Biztonsági okokból kérjük, írja be újra a jelenlegi jelszavát.",
    "disable no access": "Ha már nincs hozzáférése a fiókhoz kapcsolt hitelesítő alkalmazáshoz, jelszóváltoztatásra van szükség a kétfaktoros hitelesítés letiltásához.",
    "disabled": "Letiltva",
    "disabled two FA": "A kétfaktoros hitelesítés letiltása sikeresen megtörtént.",
    "enabled": "Engedélyezve",
    "enter": "Belépés",
    "enter current password": "Írja be az aktuális jelszót",
    "generate key description": "A folyamat befejezéséhez szüksége lesz egy hitelesítő mobilalkalmazásra, például az alábbiak egyikére:",
    "incorrect code": "Helytelen kód",
    "incorrect password": "Helytelen jelszó",
    "lowercase letter": "Legalább egy kisbetű (a–z)",
    "minimum characters": "Legalább {{maxNumber}} karakter",
    "minimum digits": "Legalább egy szám",
    "password": "Jelszó",
    "password too long": "A jelszó nem tartalmazhat több mint {{maxNumber}} karaktert",
    "passwords must match": "A jelszavaknak meg kell egyezniük",
    "reset password success": "A jelszava megváltozott.",
    "scan QR code": "Olvassa be a QR-kódot az alkalmazásába",
    "six digit code": "Az alkalmazás által generált 6 számjegyű kód",
    "special character": "Legalább egy speciális karakter (!@#$%^&*()-_=+)",
    "success description": "Sikeresen engedélyezte a kétfaktoros hitelesítést.",
    "two-factor authentication": "Kétfaktoros hitelesítés",
    "two-factor authentication description": "A kétfaktoros hitelesítés egy további biztonsági réteg, amely a felhasználó személyazonosságát egy általa ismert adat (jelszó) és egy általa birtokolt eszköz (telefon, biztonsági kulcs) segítségével ellenőrzi.",
    "two-factor authentication enabled": "A kétfaktoros hitelesítés sikeresen engedélyezve.",
    "two-factor authentication status": "A kétfaktoros hitelesítés:",
    "type text code": "Írja be a szöveges kódot az alkalmazásába",
    "uppercase letter": "Legalább egy nagybetű (A–Z)"
  },
  "Schedules": {
    "activities from": "Tevékenységek",
    "activities to": "Tevékenységek",
    "apply button tooltip": "Válasszon ki legalább egy {{resourceName}} elemet, majd ütemezze be az Alkalmazás gombra kattintva.",
    "confirm bulk quick schedule": "A kiválasztott járművezetők számára gyors menetrendet készít. Folytatni kívánja?",
    "confirm close": {
      "description": {
        "drivers": {
          "not selected": "Kiválasztott vezetőket, de még nem választott vagy alkalmazott menetrendet. Biztosan folytatni szeretné?",
          "selected": "Kiválasztott egy menetrendet, de nem alkalmazta azt. Szeretné alkalmazni a menetrendet a kiválasztott járművezetőkre?"
        },
        "vehicles": {
          "not selected": "Kiválasztott járművek vannak, de még nem választott vagy alkalmazott menetrendet. Biztosan folytatni szeretné?",
          "selected": "Kiválasztott egy ütemtervet, de nem alkalmazta. Szeretné alkalmazni az ütemtervet a kiválasztott járművekre?"
        }
      },
      "title": {
        "not selected": "Nincs kiválasztott vagy alkalmazott ütemezés.",
        "selected": "Az ütemterv nem került alkalmazásra."
      }
    },
    "confirm delete": {
      "description": {
        "drivers": "Biztosan törölni szeretné a „{{scheduleName}}” menetrendet? Ez a művelet visszafordíthatatlan, és minden olyan járművezetőre hatással lesz, akire ez a menetrend vonatkozik.",
        "vehicles": "Biztosan törölni szeretné a „{{scheduleName}}” menetrendet? Ez a művelet visszafordíthatatlan, és minden olyan járművet érint, amelyre ez a menetrend vonatkozik."
      },
      "title": "Törölni az ütemezést?"
    },
    "create new schedule": "Új menetrend létrehozása",
    "data types": "Adattípusok",
    "days": "napok",
    "details remove schedule": {
      "description": "Biztosan el akarja távolítani a „{{scheduleName}}” nevű menetrendet?",
      "title": "A menetrend eltávolítása?"
    },
    "download activities": {
      "date info tooltip": "A tevékenység időtartamának legalább két napra kell kiterjednie.",
      "tooltip text": "A TachoSync adaptív letöltési tartományt használ, amely az utolsó sikeres adatletöltés alapján automatikusan módosítja a letöltési időszakot, így biztosítva a folyamatosságot. Ez minimálisra csökkenti az adathiányokat, és garantálja, hogy mindig a legfrissebb adatokkal rendelkezzen, még akkor is, ha egy ütemezett letöltés néhány napig nem fejeződik be."
    },
    "driver number": "Járművezető {{driverNum}}",
    "driver schedules": {
      "description": "A járművezetői ütemtervek segítségével automatizálhatja a kiválasztott járművezetők tachográf-adatainak letöltését. Válassza ki azokat a járművezetőket, akikre az ütemtervet alkalmazni szeretné. Válasszon egy ütemtervet a listából, majd kattintson az „Alkalmazás” gombra az aktiváláshoz. Szükség szerint létrehozhat, szerkeszthet és törölhet ütemterveket. Megjegyzés: Minden vállalatnak egyszerre legfeljebb 3 járművezetői ütemterve lehet.",
      "description read-only": "A járművezetői ütemtervek segítségével automatizálhatja a kiválasztott járművezetők tachográf-adatainak letöltését. A vállalati rendszergazdák szükség szerint létrehozhatnak, szerkeszthetnek és törölhetnek ütemterveket.",
      "title": "Járművezetői beosztások"
    },
    "due date": "Határidő",
    "edit schedule": {
      "description": {
        "drivers": {
          "global": "A globális ütemterv automatikusan alkalmazásra kerül minden újonnan hozzáadott sofőrre. Ez az általános beállításokban módosítható.",
          "not global": "A menetrendben végrehajtott változtatások minden olyan járművezetőt érintenek, akire a menetrend vonatkozik."
        },
        "vehicles": {
          "global": "A globális ütemterv automatikusan alkalmazásra kerül minden újonnan hozzáadott járműre. Ez az általános beállításokban módosítható.",
          "not global": "A menetrendben végrehajtott változtatások minden olyan járművet érintenek, amelyre a menetrend vonatkozik."
        }
      },
      "title": {
        "global": "Globális ütemterv",
        "not global": "Menetrend szerkesztése"
      }
    },
    "enter days": "Napok megadása",
    "every": "Minden",
    "fail reason": "Hiba oka",
    "file types": {
      "Activities": "Tevékenységek",
      "DetailedSpeed": "Részletes sebesség",
      "EventsAndFaults": "Események és hibák",
      "Overview": "Áttekintés",
      "TechnicalData": "Műszaki adatok"
    },
    "global schedule": {
      "connected to root company": "Csatlakozik a központi vállalat globális ütemtervéhez.",
      "global icon info": "A globális ütemezés automatikusan érvényes lesz minden újonnan regisztrált {{specificGlobalSchedule}}-ra. Ezt az opciót a vállalati beállításokban letilthatja.",
      "info": {
        "edit driver schedule": "A globális menetrend automatikusan érvényes lesz minden újonnan regisztrált sofőrre. Ezt az opciót a vállalati beállításokban letilthatja.",
        "edit schedule": "A globális ütemezés automatikusan érvényes lesz minden újonnan regisztrált {{ variableName }}-ra. Ezt az opciót a vállalati beállításokban letilthatja.",
        "edit vehicle schedule": "A globális ütemterv automatikusan érvényes lesz minden újonnan regisztrált járműre. Ezt a beállítást a vállalati beállításokban lehet kikapcsolni."
      },
      "inherited settings": "Az anyavállalat globális ütemezési beállításait az összes leányvállalat automatikusan átveszi.",
      "not configured description": "Nyomja meg a Szerkesztés gombot az Általános ütemterv beállításának megkezdéséhez.",
      "not configured description read-only": "A menetrend részletei a konfigurálás után jelennek meg.",
      "not configured title": "A globális ütemterv nincs beállítva.",
      "not connected to root company": "Nincs csatlakozva a gyökérvállalat globális ütemtervéhez."
    },
    "include driver data": "A járművezetői adatok bevonása",
    "include driver data tooltip": "Válassza ki, hogy a gyors ütemezés során letöltse-e a futásidő-mérőbe a végrehajtás pillanatában behelyezett járművezető(k) kártyájának adatait is.\n<ul><li>Nincs – Csak a jármű (VU) adatai kerülnek letöltésre.</li><li>1. járművezető / 2. járművezető – Letölti az adatokat a kiválasztott tachográf-nyílásból, ha járművezetői kártya van benne.</li><li>Mindkét vezető – Adatokat tölt le mindkét nyílásból, ha kártyák vannak behelyezve.</li></ul>Ha a végrehajtás során nincs vezetői kártya behelyezve a kiválasztott nyílásba, a vezetői adatok nem kerülnek letöltésre.",
    "max number reached": "Elérte a megengedett menetrendek maximális számát.",
    "name not valid": "Az ütemezés neve nem tartalmazhat több mint {{maxNumber}} karaktert",
    "next attempt": "Következő kísérlet",
    "next date": "Következő időpont",
    "next date and time": "Következő dátum és időpont",
    "next due date": "Következő esedékességi dátum",
    "quick schedule": {
      "description": "Válassza ki a letölteni kívánt adattípusokat.",
      "driver schedule quick download new": "Egyszeri ütemezést hoz létre a járművezetői fájlok letöltéséhez. Az ütemezés akkor hajtódik végre, amint a járművezető csatlakozik az alkalmazáshoz.",
      "info banner": {
        "drivers": "Ez egy egyszeri ütemezés. A járművezető adatainak letöltése azonnal megkezdődik, amint a járművezető kapcsolata a TachoSync-kel azonosításra kerül.",
        "vehicles": "Ez egyszeri ütemezés. A járműadatok letöltése megkezdődik, amint a jármű kapcsolata a TachoSync-kel azonosításra kerül."
      },
      "success banner": "Az ütemezés elkészült, a „Ütemezés eltávolítása” gombra kattintva eltávolítható",
      "title": "Gyors ütemterv",
      "vehicle schedule quick download deactivated": "A gyors ütemezés nem indítható el deaktivált járműveken. Ha új gyors ütemezést szeretne indítani, először aktiválja a járművet.",
      "vehicle schedule quick download new": "Egyszeri ütemezést hoz létre a járműfájlok letöltéséhez. Az ütemezés akkor kerül végrehajtásra, amint a jármű csatlakozik az alkalmazáshoz."
    },
    "repeat": "Ismétlés",
    "repeat every": "Ismétlés minden",
    "repeat period": {
      "Biweekly": "14 naponta",
      "Custom": "Egyedi",
      "Daily": "Napi",
      "Every28Days": "28 naponta",
      "Every90Days": "90 naponta",
      "EveryDays": "Minden {{count}} nap",
      "Hourly": "Óradíj",
      "Monthly": "Havi",
      "Weekly": "7 naponta"
    },
    "schedule details": "„{{scheduleName}}” részletei",
    "select date": "Dátum kiválasztása",
    "start date": "Kezdési dátum",
    "start date and time": "Kezdési dátum és idő",
    "vehicle schedules": {
      "description": "A járműütemtervek segítségével automatizálhatja a kiválasztott járművek tachográf-adatainak letöltését. Válassza ki azokat a járműveket, amelyekre ütemtervet szeretne alkalmazni. Válasszon egy ütemtervet a listából, majd kattintson az „Alkalmazás” gombra az aktiváláshoz. Szükség szerint létrehozhat, szerkeszthet és törölhet ütemterveket. Megjegyzés: Minden vállalat egyszerre legfeljebb 3 járműütemtervet tarthat fenn.",
      "description read-only": "A járműütemtervek segítségével automatizálhatja a kiválasztott járművek tachográf-adatainak letöltését. A vállalati rendszergazdák szükség szerint létrehozhatnak, szerkeszthetnek és törölhetnek ütemezéseket.",
      "download data activities tooltip hourly": "A tevékenységek az aktuális napra vonatkozóan kerülnek letöltésre",
      "download data activities tooltip monthly": "Minden futtatás előtt az elmúlt teljes hónap tevékenységei letöltésre kerülnek",
      "download data activities tooltip multiple": "A tevékenységek az egyes futási dátumokat megelőző utolsó {{repeatDays}} napra vonatkozóan kerülnek letöltésre",
      "download data activities tooltip single": "A tevékenységek az egyes futási dátumokat megelőző utolsó napról kerülnek letöltésre",
      "title": "Járműmenetrendek"
    }
  },
  "Search": {
    "find device": {
      "error not valid": "Az IMEI-számnak 15 karakterből kell állnia",
      "find device": "Eszköz keresése",
      "no vehicle found": "Nem található jármű",
      "no vehicle found description": "A jármű nem található. Kérjük, próbálja meg beírni egy másik eszköz IMEI-számát.",
      "only numbers": "Csak számok érvényesek",
      "search for vehicles by their IMEI": "Járművek keresése az eszköz IMEI-száma alapján",
      "search vehicle IMEI": "Eszköz IMEI-számának keresése"
    },
    "search": "Keresés...",
    "search child company": "Leányvállalat keresése",
    "search company name": "Cégnév keresése",
    "search in driverFiles": "Keresés sofőr vagy sofőr-azonosító alapján",
    "search in drivers": "Keresés név vagy sofőr-azonosító alapján",
    "search in integrations": "Név szerinti keresés",
    "search in users": "Keresés e-mail cím alapján",
    "search in vehicleFiles": "Keresés FM-eszköz IMEI- vagy VRN-száma alapján",
    "search in vehicles": "Keresés FM-eszköz IMEI- vagy VRN-száma alapján"
  },
  "Security": {
    "2FA": {
      "get email code": {
        "description": "Használja ezt a kódot a következő képernyőn a fiókja igazolásához.",
        "description modal": "Használja ezt a kódot a fiókja igazolásához.",
        "title": "A „Kód elküldése” gomb megnyomásával egy egyedi kód kerül elküldésre a <1>{{email}}</1> címre."
      },
      "select authentication type": {
        "authentication app description": "Szerezzen be egy egyedi kódot egy olyan alkalmazásból, mint a Microsoft Authenticator vagy a Google Authenticator.",
        "description": "Fiókja és ügyféladatai biztonsága érdekében kérjük, használja az alábbi lehetőségek egyikét a kétfaktoros hitelesítés beállításához.",
        "description modal": "Válassza ki a kívánt hitelesítési módszert.",
        "email": "E-mail",
        "email description": "Minden bejelentkezési kísérletkor egyszeri kódot küldünk az e-mail címére.",
        "recommended": "Ajánlott",
        "title": "A kétfaktoros hitelesítés (2FA) minden TachoSync-felhasználó számára kötelező.",
        "title modal": "Válassza ki a hitelesítési módszert"
      },
      "send email code": {
        "description": "Kérjük, írja be a kódot az alábbi mezőbe, majd nyomja meg az „Ellenőrzés” gombot a folytatáshoz.",
        "enter code": "Kérjük, írja be a kódot az e-mail cím ellenőrzéséhez.",
        "title": "Egy egyedi kódot küldtünk a <1>{{email}}</1> címre.",
        "verification code": "Ellenőrző kód"
      },
      "send otp code": {
        "click to scan code": "Kattintson ide, ha inkább QR-kódot szeretne beolvasni",
        "click to type code": "Kattintson ide, ha a kódot inkább kézzel szeretné beírni",
        "incorrect code": "Helytelen kód",
        "scan QR code": "Olvassa be a QR-kódot az alkalmazásába",
        "six digit code": "Az alkalmazás által generált 6 számjegyű kód",
        "title": "A folyamat befejezéséhez szüksége lesz egy hitelesítő mobilalkalmazásra, például: <1>Microsoft Authenticator</1> vagy <2>Google Authenticator</2>.",
        "type text code": "Írja be a szöveges kódot az alkalmazásába"
      },
      "success message": {
        "alert": "A kétfaktoros hitelesítés sikeresen engedélyezve.",
        "description": "Minden alkalommal, amikor e-mail címével és jelszavával jelentkezik be, hitelesítési kódot kérünk Öntől.",
        "title": "Sikeresen engedélyezte a kétfaktoros hitelesítést.",
        "title modal": "Kétfaktoros hitelesítés engedélyezve!"
      },
      "title": {
        "authentication app": "Hitelesítő alkalmazás",
        "authentication email": "Hitelesítő e-mail",
        "is enabled": "Kétfaktoros hitelesítés engedélyezve.",
        "protect your account": "Védje TachoSync-fiókját"
      }
    }
  },
  "Selector": {
    "client company": "Ügyfélvállalat",
    "companies": "Vállalatok ({{companyCount}})",
    "company selector": "Vállalatválasztó"
  },
  "Settings": {
    "CCA file size": "Fájlméret: 83,5 MB",
    "change password": "Jelszó módosítása",
    "company card authenticator": "Céges kártya-hitelesítő",
    "email notifications": {
      "credits purchased": "Megvásárolt kreditek",
      "low credits alerts": "Alacsony kreditállományról szóló figyelmeztetések",
      "title": "E-mailes értesítések",
      "tooltip": "Állítsa be, hogy milyen hitelekkel kapcsolatos e-maileket szeretne kapni."
    },
    "feature switches": "Funkciókapcsolók",
    "file format settings": {
      "description": "Válassza ki, milyen formátumban jelenjenek meg a tachográf-fájlok. A lehetséges formátumok: európai (.DDD), francia (.V1B a járműadatokhoz és .C1B a vezetőadatokhoz) és spanyol (.TGD).",
      "title": "Fájlformátum-beállítások"
    },
    "file formats": {
      "DDD": ".DDD",
      "TGD": ".TGD",
      "V1BC1B": ".V1B, .C1B"
    },
    "general settings": "Általános beállítások",
    "security": "Biztonság",
    "time settings": {
      "date display format tooltip": "Válassza ki a dátum megjelenítési formátumát a TachoSync alkalmazásban.\nPéldául: DD-MM-YYYY = 14-05-2024",
      "description": "Állítsa be az időzónát automatikusan a jelenlegi tartózkodási helye alapján, vagy válassza ki a kívánt időzónát és azt a formátumot, amelyben az összes időbélyeg megjelenik.",
      "time and date format toggle": "Az idő és a dátum formátumának automatikus beállítása",
      "title": "Időbeállítások"
    },
    "tutorials": "Oktatóanyagok",
    "version": "Verzió"
  },
  "Table": {
    "activity period": "Tevékenységi időszak",
    "Automatic initial Driver Download": "Automatikus kezdeti járművezető-letöltés",
    "Automatic initial Vehicle Download": "Automatikus járműadatok letöltése",
    "card name": "Név",
    "card number": "Járművezető azonosítója",
    "cardnumber": "Járművezető azonosítója",
    "comment": "Megjegyzés",
    "company": "Vállalat",
    "connection status": "Kapcsolat állapota",
    "created at": "Létrehozva:",
    "created by": "Készítette:",
    "credit status": "Hitelképesség",
    "data types": "Adattípusok",
    "day ago": "1 nappal ezelőtt",
    "days ago": "{{daysNum}} napja",
    "description": "Leírás",
    "device imei": "Eszköz IMEI-száma",
    "device imei empty": "A járműhöz nincs hozzáadva IMEI-szám. Az eszköz csatlakoztatásához és a fájlok letöltéséhez érvényes IMEI-szám szükséges. Lépjen a jármű szerkesztéséhez, és adjon meg egy érvényes IMEI-számot, hogy lehetővé váljon a járműfájlok letöltése.",
    "device status": "Az eszköz állapota",
    "downloaded at": "Letöltve:",
    "driver": "Járművezető",
    "driver name": "A járművezető neve",
    "drivers name": "A járművezető neve",
    "email": "E-mail",
    "empty table": {
      "button": {
        "add": {
          "analysis providers": "Integráció hozzáadása",
          "driver files": "Sofőrfájl hozzáadása",
          "drivers": "Sofőr hozzáadása",
          "integrations": "Integráció hozzáadása",
          "integrations api": "Integráció hozzáadása",
          "users": "Felhasználó meghívása",
          "vehicle files": "Járműfájl hozzáadása",
          "vehicles": "Jármű hozzáadása"
        },
        "reset view": "Nézet visszaállítása"
      },
      "no initial results": {
        "description": {
          "analysis providers": "Amint az elemzési szolgáltatók felkerülnek a TachoSync-be, \nitt láthatja majd a listát.",
          "companies": "Amint a vállalatok felkerülnek a TachoSync rendszerbe,\nitt láthatja majd a listát.",
          "company cards": "Amint hozzáadják a vállalati kártyákat, itt láthatja majd a listát.",
          "driver files": "Amint a járművezetői fájlok felkerülnek a TachoSync-be,\nitt láthatja majd a listát.",
          "drivers": "Amint a járművezetők felkerülnek a TachoSync rendszerbe,\nitt láthatja majd a listát.",
          "integrations": "Amint az integrációk felkerülnek a TachoSync-be, \nitt tekintheti meg a listát.",
          "integrations api": "Amint az API-kulcsokat hozzáadja a TachoSync-hez,\nitt láthatja majd a listát.",
          "users": "Amint a felhasználók felkerülnek a TachoSync rendszerbe, \nitt láthatja majd a listát.",
          "users invitations": "Amint a felhasználókat meghívják a TachoSync-be,\nitt láthatja majd a listát.",
          "vehicle files": "Amint a járműfájlok felkerülnek a TachoSync-be,\nitt láthatja majd a listát.",
          "vehicles": "Amint a járművek felkerülnek a TachoSync rendszerbe,\nitt láthatja majd a listát."
        },
        "title": {
          "analysis providers": "Még nincsenek elemzési szolgáltatók",
          "companies": "A vállalatok táblázata üres",
          "company cards": "A vállalati kártyák táblázata üres",
          "driver files": "A járművezetői fájlok táblája üres",
          "drivers": "A járművezetők táblázata üres",
          "integrations": "Még nincsenek integrációk",
          "integrations api": "Még nincsenek API-kulcsok",
          "users": "A felhasználók táblája üres",
          "users invitations": "A felhasználói meghívások táblája üres",
          "vehicle files": "A járműfájlok táblázata üres",
          "vehicles": "A járművek táblázata üres"
        }
      },
      "no results found": {
        "description": "Próbáljon ki egy másik kulcsszót vagy szűrőt a további \neredményekért.",
        "title": "Nem találtunk találatokat"
      }
    },
    "enable": "Engedélyezés",
    "expiration date": "Lejárati dátum",
    "expired integration tooltip": "Az integráció lejárt, és nem lehet aktiválni",
    "file name": "Fájlnév",
    "Global schedule": "Globális ütemterv",
    "imei": "IMEI",
    "invitation status": "Meghívás állapota",
    "invited at": "Meghívott vendég",
    "invited by": "Meghívója",
    "last activity": "Utolsó tevékenység",
    "last connected": "Utolsó csatlakozás",
    "last connection": "Utolsó csatlakozás",
    "last download": "Utolsó letöltés",
    "last download date": "Utolsó letöltés: {{date}}",
    "last event": "Legutóbbi esemény",
    "last vehicle used": "Utoljára használt jármű",
    "method": "Módszer",
    "name": "Név",
    "next download": "Következő letöltés",
    "No schedule applied": "Nincs alkalmazott ütemterv",
    "No schedules": "Nincs menetrend",
    "number": "Szám",
    "Overdue": "Késedelmes",
    "parent company": "Anyavállalat",
    "plate number": "Rendszám",
    "provider": "Szolgáltató",
    "Quick schedule": "Gyors ütemterv",
    "role": "Feladat",
    "rows per page": "Sorok száma oldalonként",
    "schedule": "Ütemezés",
    "schedules": "Menetrendek",
    "seen at": "Látva:",
    "select columns to show": "Megjelenítendő oszlopok kiválasztása",
    "show details": {
      "companies": "Cégadatok megjelenítése",
      "drivers": "A járművezető adatainak megjelenítése",
      "integrations": "Az integráció részleteinek megjelenítése",
      "vehicles": "Járműadatok megjelenítése"
    },
    "status": "Állapot",
    "today": "Ma",
    "updated at": "Frissítve:",
    "vehicle": "Jármű",
    "vehicle name": "Jármű neve",
    "vehicle number": "VRN",
    "vehicles": "Járművek"
  },
  "Tabs": {
    "analysis providers": "Elemzési szolgáltatók",
    "api": "API",
    "invitations": "Meghívók",
    "sftp": "SFTP",
    "users": "Felhasználók"
  },
  "Tooltip": {
    "delete company action": "Egy vagy több kiválasztott vállalatnak leányvállalatai vannak, ezért azokat nem lehet törölni. A kiválasztott vállalatok törléséhez először törölje az összes leányvállalatot.",
    "no action permission": "Nincs jogosultsága erre a műveletre",
    "parent company": "A vállalati fa szerkezetében megengedett maximális vállalati szintek száma {{maxAllowedLevels}}. A „{{companyName}}” vállalat a {{maxAllowedLevels}}. szinten található, és hozzá nem lehet további leányvállalatokat hozzáadni."
  },
  "Tutorials": {
    "add company card": {
      "desktop": {
        "fifth step": {
          "content": "Új vállalati kártya hozzáadásához kattintson a kiemelt „Új<strong> </strong>hozzáadása” gombra. Amikor megjelenik a vállalat hozzáadása képernyő, töltse ki a szükséges mezőket, majd kattintson a „Mentés” gombra a művelet befejezéséhez.\n\nMegjegyzés: A vállalati kártya azonosítója a Vállalati kártya-hitelesítőben, a Kártya azonosító oszlopban található.\n\nA folytatáshoz kattintson a <strong>„Tovább</strong>” gombra.",
          "title": "Új vállalati kártya hozzáadása"
        },
        "final step": {
          "content": "Az összes hozzáadott kártya és azok adatai a „Vállalati kártyák” alatt jelennek meg.\n\nMegjegyzés: Ezt az oktatóanyagot bármikor újra elvégezheti a „Beállítások” – „Oktatóanyagok” menüpontban. \n\nKattintson a <strong>„Befejezés</strong>” <strong>gombra</strong> az oktatóanyag befejezéséhez.",
          "title": "A vállalati kártya adatai"
        },
        "first step": {
          "content": "Mielőtt vállalati kártyát adna hozzá a TachoSync alkalmazáshoz, győződjön meg arról, hogy letöltötte és telepítette a Company Card Authenticator alkalmazást. Ezt bármikor elvégezheti a Beállítások menüből.\n\nA Company Card Authenticator beolvassa és megjeleníti a kártyaolvasóba helyezett vállalati kártyák adatait, valamint lehetővé teszi a távoli hitelesítést.\n\nKattintson a<strong> </strong>„<strong>Kezdés</strong>” <strong>gombra</strong> a folyamat elindításához.",
          "title": "Céges kártya-hitelesítő"
        },
        "fourth step": {
          "content": "A jobb oldalon látható a vállalati adatok panele. Itt megtalálhatók az létrehozott vállalattal kapcsolatos összes információ.\n\nA folytatáshoz kattintson a <strong>„Tovább</strong>” gombra.",
          "title": "Cégadatok"
        },
        "second step": {
          "content": "A bal oldali oldalsáv segítségével lépjen a kiemelt  <strong>Vállalatok</strong> oldalra.",
          "title": "Vállalatok oldala"
        },
        "third step": {
          "content": "A vállalati kártyák képernyőjének megtekintéséhez először kattintson az egyik vállalatra.\n\nEhhez az oktatóanyaghoz válassza ki a táblázat tetején található, kiemelt vállalatot.",
          "title": "Válasszon egy vállalatot"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Új vállalati kártya hozzáadásához kattintson a kiemelt „Új hozzáadása” gombra. Amikor megjelenik a vállalat hozzáadása képernyő, töltse ki a szükséges mezőket, majd kattintson a „Mentés” gombra a művelet befejezéséhez.\n\nMegjegyzés: A vállalati kártya azonosítója a Vállalati kártya-hitelesítőben, a Kártya-azonosító táblázat oszlopában található.\n\nA folytatáshoz kattintson a <strong>„Tovább</strong>” gombra.",
          "title": "Új vállalati kártya hozzáadása"
        },
        "final step": {
          "content": "Az összes hozzáadott kártya a kiemelt „Vállalati kártyák” alatt jelenik meg. Ott láthatja a kártya állapotát, érvényességi idejét és azonosítóját.\n\nMegjegyzés: Ezt az oktatóanyagot bármikor újra elvégezheti a „Beállítások” – „Oktatóanyagok” menüpontban. \n\nKattintson a <strong>„Befejezés</strong>” g<strong>ombra</strong> az oktatóanyag befejezéséhez.",
          "title": "A vállalati kártya adatai"
        },
        "first step": {
          "content": "Először a <strong>Vállalatok </strong>oldalra kell lépnünk, amely a menüben, a jobb felső sarokban található.\n\nKattintson a kiemelt területre a <strong>menü</strong> megnyitásához.",
          "title": "Menü megnyitása"
        },
        "fourth step": {
          "content": "Itt megtalálhatja az alapított vállalattal kapcsolatos összes információt.\n\nA folytatáshoz kattintson a <strong>„Tovább</strong>” gombra.",
          "title": "Cégadatok"
        },
        "second step": {
          "content": "A <strong>„Vállalatok” oldal</strong> megnyitásához kattintson a kiemelt területre.",
          "title": "Vállalatok oldala"
        },
        "third step": {
          "content": "Itt tekintheti meg az összes vállalat listáját.\nHa meg szeretné tekinteni egy vállalat adatait, kattintson a kiemelt gombra, hogy megnyissa a <strong>vállalat adatait tartalmazó</strong> képernyőt.",
          "title": "További részletek"
        }
      },
      "name": "Cégkártya hozzáadása"
    },
    "add vehicle": {
      "first step": {
        "content": "Az ütemterv alkalmazásához legalább egy járművet hozzá kell adnia.\n\nAdjunk hozzá egy járművet a kiemelt <strong>„Jármű </strong>hozzáad<strong>ása</strong>” gombra kattintva.\n\nA következő képernyőn töltse ki az összes szükséges mezőt, majd kattintson a „Hoz<strong>zá</strong>adás” gombra a jármű hozzáadásának befejezéséhez.",
        "title": "Nincs hozzáadott jármű"
      },
      "name": "Jármű hozzáadása"
    },
    "apply schedule": {
      "desktop": {
        "fifth step": {
          "content": "Miután kiválasztotta az ütemtervet, az „Alkalmazás” gomb aktívvá válik.\n\nKattintson az „Al<strong>kalmazás</strong>” gombra.\n\nA folytatáshoz kattintson a <strong>„Tovább</strong>” gombra.",
          "title": "Válasszon ki egy alkalmazandó ütemezést"
        },
        "final step": {
          "content": "Amikor egy ütemtervet sikeresen alkalmaznak egy járműre, az adatletöltés az ütemtervben megadott időpont szerint megkezdődik.\n\nAz adott járműre vagy járművezetőre alkalmazott összes ütemterv a kiemelt „További részletek” panelen jelenik meg.\n\nKattintson a <strong>„Befejezés</strong>” <strong>gombra</strong> a bemutató befejezéséhez.",
          "title": "Az ütemterv sikeresen alkalmazva"
        },
        "first step": {
          "content": "A járművek menetrendjei a Járművek oldalon, a járművezetők menetrendjei pedig a Járművezetők oldalon találhatók.\n\nMivel a folyamat mindkét oldalon hasonló, ebben az útmutatóban válassza ki a kiemelt „<strong>Járművek</strong>” oldalt.",
          "title": "Járművek vagy járművezetők menetrendje"
        },
        "fourth step": {
          "content": "Kattintson egy ütemtervre, hogy azt a kiválasztott jármű(vek)re alkalmazza.\n\nA folytatáshoz kattintson a <strong>„Tovább</strong>” gombra",
          "title": "Válasszon ki egy alkalmazandó ütemtervet"
        },
        "second step": {
          "content": "Mielőtt egy menetrendet alkalmazna, válasszon ki egy vagy több járművet.\n\nEhhez az oktatóanyaghoz válassza ki <strong>a táblázat első járművét</strong>  a kiemelt gombra kattintva.",
          "title": "Válasszon járművet"
        },
        "third step": {
          "content": "Miután kiválasztotta a járművet, a „Menetrendek” gomb aktívvá válik.\n\nKattintson a kiemelt <strong>„Menetrendek</strong>” gombra a folytatáshoz.",
          "title": "Nyitott menetrendek"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Miután kiválasztotta a járművet, a „Menetrendek” gomb kiemelve jelenik meg.\n\nKattintson a kiemelt „<strong>Menetrendek</strong>” gombra a folytatáshoz.",
          "title": "Nyitott menetrendek"
        },
        "final step": {
          "content": "Amikor egy ütemtervet sikeresen alkalmaznak egy járműre, az adatletöltés az ütemtervben megadott időpont szerint megkezdődik.\nAz összes, járműre vagy járművezetőre alkalmazott ütemterv a kiemelt „<strong>További részletek</strong>” panelen jelenik meg.\n\nKattintson a <strong>„Befejezés</strong>” <strong>gombra</strong> a bemutató befejezéséhez.",
          "title": "Az ütemterv sikeresen alkalmazva"
        },
        "first step": {
          "content": "A járművek menetrendjei a Járművek oldalon, a járművezetők menetrendjei pedig a Járművezetők oldalon találhatók.\n\nMivel a folyamat mindkét oldalon hasonló, ebben az oktatóanyagban válasszuk ki a kiemelt <strong>„Járművek oldal”</strong> lehetősé<strong>get</strong>.",
          "title": "Járművek vagy járművezetők menetrendje"
        },
        "fourth step": {
          "content": "Ebben az oktatóanyagban válasszuk ki a táblázat első járművét a kiemelt gombra kattintva.",
          "title": "Válasszon járművet"
        },
        "second step": {
          "content": "Mivel a folyamat mindkét oldalon hasonló, ebben az oktatóanyagban válasszuk ki a kiemelt „<strong>Járm</strong>űvek”<strong> oldalt</strong>.",
          "title": "Járművek oldal"
        },
        "seventh step": {
          "content": "Miután kiválasztott egy ütemtervet, a kiemelt <strong>„Alkalmazás</strong>” gomb aktiválódik. Ha rákattint, az ütemterv a kiválasztott járműre kerül alkalmazásra.\n\nA folytatáshoz kattintson a <strong>„Tovább</strong>” gombra.",
          "title": "Válasszon ki egy alkalmazandó ütemtervet"
        },
        "sixth step": {
          "content": "A jármű kiválasztása után rákattintva kiválaszthat egy alkalmazandó ütemtervet.\n\nA folytatáshoz kattintson a <strong>„Tovább</strong>” gombra",
          "title": "Válasszon ki egy alkalmazandó ütemtervet"
        },
        "third step": {
          "content": "Mielőtt menetrendet rendelne hozzájuk, először ki kell választania egy vagy több járművet.\nA kezdéshez kattintson a kiemelt <strong>„Sorok kiv</strong>ál<strong>asztása</strong>” gombra.",
          "title": "Kiválasztási eszköz megnyitása"
        }
      },
      "name": "Menetrend alkalmazása"
    },
    "company selector": {
      "desktop": {
        "first step": {
          "content": "A felső menüben található vállalatválasztó segítségével kiválaszthatja azt a vállalatot, amellyel a TachoSync alkalmazásban együttműködni szeretne.\nErre akkor van szükség, ha egynél több vállalatot kezel.\n\nKattintson a <strong>kiemelt</strong> gombra a vállalatválasztó megnyitásához.",
          "title": "Cégválasztó megnyitása"
        },
        "second step": {
          "content": "A Vállalatválasztó képernyőn kiválaszthatja azt a vállalatot, amellyel együtt kíván dolgozni. Az egyéb menükben csak a kiválasztott vállalathoz kapcsolódó erőforrások jelennek meg. A TachoSync-ből való kijelentkezéskor a rendszer mindig elmenti az utoljára használt beállítást.",
          "title": "Vállalatválasztó"
        }
      },
      "mobile": {
        "first step": {
          "content": "A felső menüben található vállalatválasztó segítségével kiválaszthatja azt a vállalatot, amellyel a TachoSync alkalmazásban együttműködni szeretne.\nErre akkor van szükség, ha egynél több vállalatot kezel.\n\nKattintson a <strong>kiemelt</strong> gombra a vállalatválasztó megnyitásához.",
          "title": "Cégválasztó megnyitása"
        },
        "second step": {
          "content": "A Vállalatválasztó képernyőn kiválaszthatja azt a vállalatot, amellyel együtt kíván dolgozni. A többi menüben csak a kiválasztott vállalathoz kapcsolódó erőforrások jelennek meg. A TachoSync-ből való kijelentkezéskor a rendszer mindig elmenti az utoljára használt választást.",
          "title": "Vállalatválasztó"
        }
      },
      "name": "Vállalatválasztó"
    },
    "create schedule": {
      "desktop": {
        "fifth step": {
          "content": "A menetrend létrehozása után azt a kiválasztott járművekre vagy járművezetőkre kell alkalmazni. A menetrendek alkalmazásáról az „Menetrend<strong> alkalmazása</strong>” <strong>című</strong> útmutatóban találhat további információkat.\n\nA folytatáshoz kattintson a <strong>„Tovább</strong>” gombra.",
          "title": "Az ütemterv nem került alkalmazásra"
        },
        "final step": {
          "content": "Gratulálunk, sikeresen elsajátította az ütemterv létrehozásának módját.\n\nEzután tanulja meg, hogyan alkalmazhatja az ütemtervet a kiválasztott elemekre.\n\nKattintson a <strong>„Befejezés</strong>” gombra az oktatóanyag befejezéséhez.",
          "title": "Menetrend létrehozása – befejezve"
        },
        "first step": {
          "content": "Az ütemezés egy előre beállított terv, amely meghatározott időpontokban és időközönként automatikusan letölti a járművekből vagy a járművezetőktől származó tachográf-adatokat. A kezdő dátum, időpont és gyakoriság (például naponta) beállításával az ütemezés biztosítja, hogy az adatok rendszeresen összegyűjtésre kerüljenek, manuális beavatkozás nélkül.\n\nKattintson a<strong> </strong>„<strong>Kezdés</strong>” <strong>gombra</strong> az induláshoz.",
          "title": "Mi az a menetrend?"
        },
        "fourth step": {
          "content": "Ezen a képernyőn létrehozhat, szerkeszthet, szüneteltethet vagy eltávolíthat ütemezéseket. Az első hely mindig az Általános ütemezés számára van fenntartva, amelyet nem lehet eltávolítani.",
          "title": "Menetrendek"
        },
        "second step": {
          "content": "A járművek menetrendjei a „Járművek” oldalon találhatók. A járművezetők menetrendjei a „Járművezetők” oldalon találhatók.\n\nMivel a folyamat mindkét oldalon hasonló, ezért ebben az útmutatóban válassza ki a kiemelt <strong>„Járművek</strong>” oldalt.",
          "title": "Járművek vagy járművezetők menetrendje"
        },
        "third step": {
          "content": "A menetrendeket a Menetrendek ablakban bármikor létre lehet hozni és szerkeszteni, függetlenül attól, hogy hozzáadottak-e már járműveket vagy járművezetőket.\n\nA folytatáshoz kattintson a kiemelt <strong>„Menetrendek</strong>” gombra.",
          "title": "Nyitott menetrendek"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Ezen a képernyőn létrehozhat, szerkeszthet, szüneteltethet vagy eltávolíthat bármely létrehozott ütemezést. Az első hely mindig az Általános ütemezés számára van fenntartva, amelyet nem lehet eltávolítani.",
          "title": "Menetrendek"
        },
        "final step": {
          "content": "Gratulálunk, sikeresen megtanulta, hogyan kell menetrendet létrehozni.\n\nTovább: Ismerje meg, hogyan alkalmazhat menetrendet a kiválasztott elemekre.\n\nKattintson a <strong>„Befejezés</strong>” g<strong>ombra</strong> az oktatóanyag befejezéséhez.",
          "title": "Menetrend létrehozása – befejezve"
        },
        "first step": {
          "content": "Az ütemezés egy előre beállított terv, amely meghatározott időpontokban és időközönként automatikusan letölti a járművekből vagy a járművezetőktől származó tachográf-adatokat. A kezdő dátum, időpont és gyakoriság (például naponta) beállításával az ütemezés biztosítja, hogy az adatok rendszeresen összegyűjtésre kerüljenek, manuális beavatkozás nélkül.\n\nKattintson a<strong> </strong>„<strong>Kezdés</strong>” <strong>gombra</strong> a folyamat elindításához.",
          "title": "Mi az a menetrend?"
        },
        "fourth step": {
          "content": "A menetrendeket a Menetrendek ablakban bármikor létre lehet hozni és szerkeszteni, függetlenül attól, hogy hozzáadottak-e már járműveket vagy járművezetőket.\n\nA folytatáshoz kattintson a kiemelt <strong>„Menetrendek</strong>” gombra.",
          "title": "Nyitott menetrendek"
        },
        "second step": {
          "content": "A járművek menetrendjei a Járművek oldalon, a járművezetők menetrendjei pedig a Járművezetők oldalon találhatók.\n\nAhhoz, hogy ezekre az oldalakra navigáljunk, először nyissuk meg a <strong>menüt</strong>.",
          "title": "Járművek vagy járművezetők menetrendje"
        },
        "sixth step": {
          "content": "A menetrend létrehozása után azt a kiválasztott járművekre vagy járművezetőkre kell alkalmazni. Ennek a műveletnek a végrehajtását egy másik útmutató, az<strong> „Menetrend</strong> alkalmazása” című rész ismerteti.\n\nA folytatáshoz kattintson a <strong>„Tovább</strong>” gombra.",
          "title": "Az ütemterv nem került alkalmazásra"
        },
        "third step": {
          "content": "Mivel a folyamat mindkét oldalon hasonló, ebben az oktatóanyagban válasszuk ki a kiemelt <strong>„Járművek oldal</strong>” menüpontot.",
          "title": "Járművek oldal"
        }
      },
      "name": "Menetrend létrehozása"
    }
  }
}
